import { Sprite } from 'icons'
import { Component } from 'solid-js'

export const ArrowLeftIcon = (P: any) => (
    <svg
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <Sprite id='account_arrow_left' />
    </svg>
)

export const ArrowLeft2Icon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M427 234.625H167.296l119.702-119.702L256 85 85 256l171 171 29.922-29.924-118.626-119.701H427v-42.75z'></path>
    </svg>
)

export const TelegramIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 25 25'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M2.14753 11.8099C7.3949 9.52374 10.894 8.01654 12.6447 7.28833C17.6435 5.20916 18.6822 4.84799 19.3592 4.83606C19.5081 4.83344 19.8411 4.87034 20.0567 5.04534C20.2388 5.1931 20.2889 5.39271 20.3129 5.5328C20.3369 5.6729 20.3667 5.99204 20.343 6.2414C20.0721 9.08763 18.9 15.9947 18.3037 19.1825C18.0514 20.5314 17.5546 20.9836 17.0736 21.0279C16.0283 21.1241 15.2345 20.3371 14.2221 19.6735C12.6379 18.635 11.7429 17.9885 10.2051 16.9751C8.42795 15.804 9.58001 15.1603 10.5928 14.1084C10.8579 13.8331 15.4635 9.64397 15.5526 9.26395C15.5637 9.21642 15.5741 9.03926 15.4688 8.94571C15.3636 8.85216 15.2083 8.88415 15.0962 8.9096C14.9373 8.94566 12.4064 10.6184 7.50365 13.928C6.78528 14.4212 6.13461 14.6616 5.55163 14.649C4.90893 14.6351 3.67265 14.2856 2.7536 13.9869C1.62635 13.6204 0.730432 13.4267 0.808447 12.8044C0.849081 12.4803 1.29544 12.1488 2.14753 11.8099Z'></path>
    </svg>
)

export const WhatsappIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill-rule='evenodd'
            d='M414.73 97.1A222.14 222.14 0 0 0 256.94 32C134 32 33.92 131.58 33.87 254a220.61 220.61 0 0 0 29.78 111L32 480l118.25-30.87a223.63 223.63 0 0 0 106.6 27h.09c122.93 0 223-99.59 223.06-222A220.18 220.18 0 0 0 414.73 97.1zM256.94 438.66h-.08a185.75 185.75 0 0 1-94.36-25.72l-6.77-4-70.17 18.32 18.73-68.09-4.41-7A183.46 183.46 0 0 1 71.53 254c0-101.73 83.21-184.5 185.48-184.5a185 185 0 0 1 185.33 184.64c-.04 101.74-83.21 184.52-185.4 184.52zm101.69-138.19c-5.57-2.78-33-16.2-38.08-18.05s-8.83-2.78-12.54 2.78-14.4 18-17.65 21.75-6.5 4.16-12.07 1.38-23.54-8.63-44.83-27.53c-16.57-14.71-27.75-32.87-31-38.42s-.35-8.56 2.44-11.32c2.51-2.49 5.57-6.48 8.36-9.72s3.72-5.56 5.57-9.26.93-6.94-.46-9.71-12.54-30.08-17.18-41.19c-4.53-10.82-9.12-9.35-12.54-9.52-3.25-.16-7-.2-10.69-.2a20.53 20.53 0 0 0-14.86 6.94c-5.11 5.56-19.51 19-19.51 46.28s20 53.68 22.76 57.38 39.3 59.73 95.21 83.76a323.11 323.11 0 0 0 31.78 11.68c13.35 4.22 25.5 3.63 35.1 2.2 10.71-1.59 33-13.42 37.63-26.38s4.64-24.06 3.25-26.37-5.11-3.71-10.69-6.48z'
        ></path>
    </svg>
)

export const InstagramIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M349.33 69.33a93.62 93.62 0 0 1 93.34 93.34v186.66a93.62 93.62 0 0 1-93.34 93.34H162.67a93.62 93.62 0 0 1-93.34-93.34V162.67a93.62 93.62 0 0 1 93.34-93.34h186.66m0-37.33H162.67C90.8 32 32 90.8 32 162.67v186.66C32 421.2 90.8 480 162.67 480h186.66C421.2 480 480 421.2 480 349.33V162.67C480 90.8 421.2 32 349.33 32z'></path>
        <path d='M377.33 162.67a28 28 0 1 1 28-28 27.94 27.94 0 0 1-28 28zM256 181.33A74.67 74.67 0 1 1 181.33 256 74.75 74.75 0 0 1 256 181.33m0-37.33a112 112 0 1 0 112 112 112 112 0 0 0-112-112z'></path>
    </svg>
)

export const MessageIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 24 24'
        aria-hidden='true'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill-rule='evenodd'
            d='M4.848 2.771A49.144 49.144 0 0 1 12 2.25c2.43 0 4.817.178 7.152.52 1.978.292 3.348 2.024 3.348 3.97v6.02c0 1.946-1.37 3.678-3.348 3.97a48.901 48.901 0 0 1-3.476.383.39.39 0 0 0-.297.17l-2.755 4.133a.75.75 0 0 1-1.248 0l-2.755-4.133a.39.39 0 0 0-.297-.17 48.9 48.9 0 0 1-3.476-.384c-1.978-.29-3.348-2.024-3.348-3.97V6.741c0-1.946 1.37-3.68 3.348-3.97ZM6.75 8.25a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 0 1.5h-9a.75.75 0 0 1-.75-.75Zm.75 2.25a.75.75 0 0 0 0 1.5H12a.75.75 0 0 0 0-1.5H7.5Z'
            clip-rule='evenodd'
        ></path>
    </svg>
)

export const TextIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 16 16'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z'></path>
    </svg>
)

export const PhotoIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 20 20'
        aria-hidden='true'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill-rule='evenodd'
            d='M1 5.25A2.25 2.25 0 0 1 3.25 3h13.5A2.25 2.25 0 0 1 19 5.25v9.5A2.25 2.25 0 0 1 16.75 17H3.25A2.25 2.25 0 0 1 1 14.75v-9.5Zm1.5 5.81v3.69c0 .414.336.75.75.75h13.5a.75.75 0 0 0 .75-.75v-2.69l-2.22-2.219a.75.75 0 0 0-1.06 0l-1.91 1.909.47.47a.75.75 0 1 1-1.06 1.06L6.53 8.091a.75.75 0 0 0-1.06 0l-2.97 2.97ZM12 7a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z'
            clip-rule='evenodd'
        ></path>
    </svg>
)

export const VideoIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 576 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M0 128C0 92.7 28.7 64 64 64l256 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128zM559.1 99.8c10.4 5.6 16.9 16.4 16.9 28.2l0 256c0 11.8-6.5 22.6-16.9 28.2s-23 5-32.9-1.6l-96-64L416 337.1l0-17.1 0-128 0-17.1 14.2-9.5 96-64c9.8-6.5 22.4-7.2 32.9-1.6z'></path>
    </svg>
)

export const SuggestionsIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 20 20'
        aria-hidden='true'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            style='scale: 1.25; transform-origin: center;'
            d='M11 3a1 1 0 10-2 0v1a1 1 0 102 0V3zM15.657 5.757a1 1 0 00-1.414-1.414l-.707.707a1 1 0 001.414 1.414l.707-.707zM18 10a1 1 0 01-1 1h-1a1 1 0 110-2h1a1 1 0 011 1zM5.05 6.464A1 1 0 106.464 5.05l-.707-.707a1 1 0 00-1.414 1.414l.707.707zM5 10a1 1 0 01-1 1H3a1 1 0 110-2h1a1 1 0 011 1zM8 16v-1h4v1a2 2 0 11-4 0zM12 14c.015-.34.208-.646.477-.859a4 4 0 10-4.954 0c.27.213.462.519.476.859h4.002z'
        ></path>
    </svg>
)

export const AddHomeIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        width='25'
        height='25'
        color='currentColor'
        fill='none'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
    >
        <path d='M13 10C13 11.6569 11.6569 13 10 13C8.34315 13 7 11.6569 7 10C7 8.34315 8.34315 7 10 7C11.6569 7 13 8.34315 13 10Z' />
        <path d='M21.3547 16.4469L18.8796 14.3254C18.6347 14.1154 18.3226 14 18 14C17.6774 14 17.3653 14.1154 17.1204 14.3254L14.6453 16.4469C14.2357 16.7979 14 17.3105 14 17.8499V18.5752C14 19.9081 14 20.5746 14.305 21.0616C14.4655 21.3179 14.6821 21.5345 14.9384 21.695C15.4254 22 16.0919 22 17.4248 22H18.5752C19.9081 22 20.5746 22 21.0616 21.695C21.3179 21.5345 21.5345 21.3179 21.695 21.0616C22 20.5746 22 19.9081 22 18.5752V17.8499C22 17.3105 21.7643 16.7979 21.3547 16.4469Z' />
        <path d='M18 19V22' />
        <path d='M18 10.0355C18 5.59762 14.4183 2 10 2C5.58172 2 2 5.59762 2 10.0355C2 12.5731 3 14.5462 5 16.3086C6.07535 17.2562 7.82291 19.0316 9.04653 20.5628C9.27943 20.8543 9.63972 21 10 21' />
    </svg>
)

export const AddEateryIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        width='25'
        height='25'
        color='currentColor'
        fill='none'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
        stroke-linejoin='round'
    >
        <path
            // fill='currentColor'
            d='M14.5 10.5C14.5 12.1569 13.1569 13.5 11.5 13.5C9.84315 13.5 8.5 12.1569 8.5 10.5C8.5 8.84315 9.84315 7.5 11.5 7.5C13.1569 7.5 14.5 8.84315 14.5 10.5Z'
        />
        <path
            // fill='currentColor'
            d='M17.495 14.5V20.5M20.5 17.495L14.5 17.495'
        />
        <path
            // fill='currentColor'
            d='M19.5 10.5352C19.4998 6.09743 15.9182 2.5 11.5 2.5C7.08184 2.5 3.50019 6.09743 3.5 10.5352C3.5 13.0728 4.5 15.0462 6.5 16.8086C7.57535 17.7562 9.32325 19.5313 10.5469 21.0625C10.7798 21.354 11.1397 21.5 11.5 21.5C11.8603 21.5 12.2202 21.354 12.4531 21.0625'
        />
    </svg>
)

export const NotificationIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='128'
        height='128'
        viewBox='0 0 24 24'
        fill='none'
        class='injected-svg'
        color='currentColor'
    >
        <path
            d='M21.0127 14.4502L19.75 13.1875V9.5C19.75 5.21979 16.2802 1.75 12 1.75C7.71979 1.75 4.25 5.21979 4.25 9.5V13.1875L2.9873 14.4502C2.51512 14.9225 2.25 15.5635 2.25 16.2314C2.25017 17.6223 3.37767 18.7498 4.76855 18.75H19.2314C20.6223 18.7498 21.7498 17.6223 21.75 16.2314C21.75 15.5635 21.4849 14.9225 21.0127 14.4502Z'
            fill='currentColor'
        ></path>
        <path
            d='M15.75 20C15.0345 21.3387 13.624 22.25 12 22.25C10.376 22.25 8.96548 21.3387 8.25 20H15.75Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const CopyIcon = () => (
    <svg
        style='transform:scaleX(-1)'
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 24 24'
        height='1em'
        width='1em'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M14 8H4c-1.103 0-2 .897-2 2v10c0 1.103.897 2 2 2h10c1.103 0 2-.897 2-2V10c0-1.103-.897-2-2-2z'></path>
        <path d='M20 2H10a2 2 0 0 0-2 2v2h8a2 2 0 0 1 2 2v8h2a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2z'></path>
    </svg>
)

export const FriendIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 640 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M192 256c61.9 0 112-50.1 112-112S253.9 32 192 32 80 82.1 80 144s50.1 112 112 112zm76.8 32h-8.3c-20.8 10-43.9 16-68.5 16s-47.6-6-68.5-16h-8.3C51.6 288 0 339.6 0 403.2V432c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48v-28.8c0-63.6-51.6-115.2-115.2-115.2zM480 256c53 0 96-43 96-96s-43-96-96-96-96 43-96 96 43 96 96 96zm48 32h-3.8c-13.9 4.8-28.6 8-44.2 8s-30.3-3.2-44.2-8H432c-20.4 0-39.2 5.9-55.7 15.4 24.4 26.3 39.7 61.2 39.7 99.8v38.4c0 2.2-.5 4.3-.6 6.4H592c26.5 0 48-21.5 48-48 0-61.9-50.1-112-112-112z'></path>
    </svg>
)

export const MailToSupportIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='currentColor'
        color='currentColor'
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M9.07999 1.7868C11.033 1.73773 12.967 1.73773 14.92 1.78681L14.9782 1.78827C16.503 1.82656 17.73 1.85737 18.7133 2.02862C19.7428 2.20791 20.5795 2.55179 21.2864 3.26134C21.9903 3.96792 22.3324 4.79261 22.5082 5.80542C22.6757 6.76979 22.7012 7.96683 22.7328 9.44967L22.7341 9.5084C22.7521 10.3554 22.7548 11.1981 22.7422 12.0438C22.7401 12.1868 22.739 12.2582 22.7135 12.3149C22.6829 12.3827 22.6274 12.4374 22.5591 12.4669C22.5021 12.4916 22.4301 12.4916 22.2862 12.4916C22.1817 12.4916 22.1294 12.4916 22.0865 12.4784C22.0312 12.4615 21.9906 12.4357 21.9519 12.3928C21.9217 12.3595 21.897 12.3066 21.8475 12.2009C21.1701 10.753 19.7002 9.75 17.996 9.75C15.6488 9.75 13.746 11.6528 13.746 14C13.746 14.9759 14.0749 15.8751 14.628 16.5925C14.7523 16.7537 14.7042 16.9959 14.5239 17.0904L14.5033 17.1006C14.2123 17.245 13.3599 17.6677 12.8339 18.1239C12.5123 18.4028 11.8861 19.028 11.7655 20.0057C11.7488 20.1411 11.638 20.2495 11.5017 20.2489C10.6959 20.2455 9.88959 20.2335 9.07999 20.2132L9.02177 20.2117C7.49697 20.1735 6.27001 20.1426 5.2867 19.9714C4.2572 19.7921 3.42048 19.4482 2.71362 18.7387C2.00972 18.0321 1.66764 17.2074 1.49176 16.1946C1.32429 15.2302 1.29879 14.0332 1.26719 12.5504L1.26594 12.4916C1.24469 11.4953 1.24469 10.5047 1.26593 9.50839L1.26719 9.44965C1.29878 7.9668 1.32429 6.76978 1.49176 5.8054C1.66764 4.7926 2.00971 3.9679 2.71362 3.26132C3.42048 2.55177 4.2572 2.20789 5.2867 2.0286C6.27002 1.85735 7.497 1.82655 9.02182 1.78826L9.07999 1.7868ZM7.38182 6.36623C7.02527 6.15543 6.56533 6.27358 6.35452 6.63013C6.14371 6.98669 6.26186 7.44663 6.61841 7.65744L9.56043 9.39687C10.4313 9.91175 11.1827 10.2618 12.0001 10.2618C12.8175 10.2618 13.569 9.91175 14.4398 9.39687L17.3818 7.65744C17.7384 7.44663 17.8565 6.98669 17.6457 6.63013C17.4349 6.27358 16.975 6.15543 16.6184 6.36623L13.6764 8.10567C12.832 8.60488 12.3831 8.76184 12.0001 8.76184C11.6171 8.76184 11.1682 8.60488 10.3238 8.10567L7.38182 6.36623Z'
        ></path>
        <path d='M15.2071 18.426C16.9158 17.5247 19.0768 17.5247 20.7855 18.426C21.095 18.5801 21.8018 18.9329 22.1756 19.2571C22.4085 19.4591 22.6865 19.7713 22.7381 20.1894C22.795 20.6509 22.5579 21.0489 22.1926 21.3573C21.633 21.8296 20.9114 22.25 19.9559 22.25H16.0367C15.0812 22.25 14.3596 21.8296 13.8 21.3573C13.4347 21.0489 13.1976 20.6509 13.2545 20.1894C13.3061 19.7712 13.5841 19.4591 13.8169 19.2571C14.1908 18.9329 14.8975 18.5801 15.2071 18.426Z'></path>
        <path d='M15.2463 14C15.2463 12.4812 16.4775 11.25 17.9963 11.25C19.5151 11.25 20.7463 12.4812 20.7463 14C20.7463 15.5188 19.5151 16.75 17.9963 16.75C16.4775 16.75 15.2463 15.5188 15.2463 14Z'></path>
    </svg>
)

export const AnonymouseIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='none'
        color='currentColor'
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M7.13889 16.124C6.065 16.124 5.19444 16.9635 5.19444 17.999C5.19444 19.0346 6.065 19.874 7.13889 19.874C8.21278 19.874 9.08333 19.0346 9.08333 17.999C9.08333 16.9635 8.21278 16.124 7.13889 16.124ZM3.25 17.999C3.25 15.928 4.99112 14.249 7.13889 14.249C8.57833 14.249 9.83511 15.0031 10.5075 16.124H13.4925C14.1649 15.0031 15.4217 14.249 16.8611 14.249C19.0089 14.249 20.75 15.928 20.75 17.999C20.75 20.0701 19.0089 21.749 16.8611 21.749C14.7133 21.749 12.9722 20.0701 12.9722 17.999L11.0278 17.999C11.0278 20.0701 9.28666 21.749 7.13889 21.749C4.99112 21.749 3.25 20.0701 3.25 17.999ZM16.8611 16.124C15.7872 16.124 14.9167 16.9635 14.9167 17.999C14.9167 19.0346 15.7872 19.874 16.8611 19.874C17.935 19.874 18.8056 19.0346 18.8056 17.999C18.8056 16.9635 17.935 16.124 16.8611 16.124Z'
            fill='currentColor'
        ></path>
        <path
            d='M5.31634 4.59645C5.6103 2.70968 7.67269 1.66315 9.35347 2.59225L9.96847 2.93221C11.2351 3.63236 12.7647 3.63236 14.0313 2.93221L14.6463 2.59225C16.3271 1.66315 18.3895 2.70968 18.6834 4.59644L19.7409 11.384C19.7788 11.6271 19.695 11.8734 19.5167 12.043C19.3383 12.2125 19.0882 12.2838 18.8472 12.2337C16.7318 11.7939 10.9673 11.1659 5.13538 12.2371C4.89638 12.281 4.65092 12.2064 4.47679 12.0369C4.30265 11.8674 4.22142 11.6241 4.25883 11.384L5.31634 4.59645Z'
            fill='currentColor'
        ></path>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M12.0005 11.9989C8.22613 11.9989 4.89604 12.6584 2.66477 13.6566C2.18196 13.8726 1.59501 13.6972 1.35376 13.265C1.11251 12.8327 1.30834 12.3072 1.79114 12.0912C4.3613 10.9414 8.00877 10.249 12.0005 10.249C15.9922 10.249 19.6397 10.9414 22.2098 12.0912C22.6926 12.3072 22.8885 12.8327 22.6472 13.265C22.406 13.6972 21.819 13.8726 21.3362 13.6566C19.1049 12.6584 15.7748 11.9989 12.0005 11.9989Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const GiftIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='none'
        color='currentColor'
    >
        <path
            d='M18.527 6.25C18.9713 6.24999 19.3447 6.24998 19.6492 6.27206C19.9652 6.29497 20.2721 6.34483 20.5645 6.47989C20.8957 6.63285 21.1916 6.86234 21.4072 7.1611C21.6109 7.44339 21.687 7.7475 21.7201 8.03961C21.7501 8.30406 21.75 8.62116 21.75 8.96402V9.03598C21.75 9.37885 21.7501 9.69594 21.7201 9.96039C21.687 10.2525 21.6109 10.5566 21.4072 10.8389C21.1916 11.1377 20.8957 11.3671 20.5645 11.5201C20.2721 11.6552 19.9652 11.705 19.6492 11.7279C19.3447 11.75 18.9713 11.75 18.5269 11.75H5.47308C5.0287 11.75 4.6553 11.75 4.35082 11.7279C4.03479 11.705 3.72793 11.6552 3.43552 11.5201C3.10434 11.3671 2.80841 11.1377 2.5928 10.8389C2.38907 10.5566 2.31299 10.2525 2.27989 9.96039C2.24993 9.69594 2.24997 9.37884 2.25 9.03597V8.96403C2.24997 8.62116 2.24993 8.30406 2.27989 8.03961C2.31299 7.7475 2.38907 7.44339 2.5928 7.1611C2.80841 6.86234 3.10434 6.63285 3.43552 6.47989C3.72793 6.34483 4.03479 6.29497 4.35082 6.27206C4.65529 6.24998 5.02869 6.24999 5.47306 6.25H18.527Z'
            fill='currentColor'
        ></path>
        <path
            d='M3.78678 12.9182C3.52341 12.8739 3.39172 12.8517 3.32086 12.9116C3.25 12.9715 3.25 13.0943 3.25 13.34V15.0544C3.24998 16.657 3.24997 17.936 3.38483 18.939C3.52415 19.9753 3.81966 20.8287 4.4948 21.5039C5.16994 22.179 6.02335 22.4745 7.05961 22.6138C8.0627 22.7487 9.34166 22.7487 10.9443 22.7487C10.975 22.7487 11 22.7237 11 22.6929L11 13.3987C11 13.2101 11 13.1158 10.9414 13.0572C10.8828 12.9987 10.7886 12.9987 10.6 12.9987H5.43911C5.02245 12.9987 4.61055 12.9987 4.26041 12.9733C4.11504 12.9628 3.95558 12.9467 3.78678 12.9182Z'
            fill='currentColor'
        ></path>
        <path
            d='M13.4 12.9987C13.2114 12.9987 13.1172 12.9987 13.0586 13.0572C13 13.1158 13 13.2101 13 13.3987V22.6929C13 22.7237 13.025 22.7487 13.0557 22.7487C14.6583 22.7487 15.9373 22.7487 16.9404 22.6138C17.9767 22.4745 18.8301 22.179 19.5052 21.5039C20.1803 20.8287 20.4758 19.9753 20.6152 18.939C20.75 17.936 20.75 16.657 20.75 15.0544V13.34C20.75 13.0943 20.75 12.9715 20.6791 12.9116C20.6083 12.8517 20.4766 12.8738 20.2132 12.9182C20.0444 12.9467 19.8849 12.9628 19.7396 12.9733C19.3894 12.9987 18.9776 12.9987 18.5609 12.9987H13.4Z'
            fill='currentColor'
        ></path>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M7.78571 1.25006C6.24721 1.25006 5 2.49727 5 4.03578C5 6.36326 6.8868 8.25006 9.21429 8.25006H12H14.7857C17.1132 8.25006 19 6.36326 19 4.03578C19 2.49727 17.7528 1.25006 16.2143 1.25006H15.8571C14.2852 1.25006 12.8877 1.99676 12 3.1548C11.1123 1.99676 9.71476 1.25006 8.14286 1.25006H7.78571ZM11 6.1072C11 4.52925 9.72081 3.25006 8.14286 3.25006H7.78571C7.35178 3.25006 7 3.60184 7 4.03578C7 5.25869 7.99137 6.25006 9.21429 6.25006H11V6.1072ZM13 6.25006H14.7857C16.0086 6.25006 17 5.25869 17 4.03578C17 3.60184 16.6482 3.25006 16.2143 3.25006H15.8571C14.2792 3.25006 13 4.52925 13 6.1072V6.25006Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const GiftStrokeIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        width='25'
        height='25'
        color='currentColor'
        fill='none'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linejoin='round'
    >
        <path d='M13.5 4.5C13.5 5.32843 12.8284 6 12 6C11.1716 6 10.5 5.32843 10.5 4.5C10.5 3.67157 12 2 12 2C12 2 13.5 3.67157 13.5 4.5Z'></path>
        <path d='M12 6V9' stroke-linecap='round'></path>
        <path d='M17.6667 14C19.2315 14 20.5 12.8807 20.5 11.5C20.5 10.1193 19.2315 9 17.6667 9H6.33333C4.76853 9 3.5 10.1193 3.5 11.5C3.5 12.8807 4.76853 14 6.33333 14C7.70408 14 8.90415 13.1411 9.16667 12C9.42919 13.1411 10.6293 14 12 14C13.3707 14 14.5708 13.1411 14.8333 12C15.0959 13.1411 16.2959 14 17.6667 14Z'></path>
        <path
            d='M5 14L5.52089 16.5796C6.04532 19.1768 6.30754 20.4754 7.19608 21.2377C8.08462 22 9.33608 22 11.839 22H12.161C14.6639 22 15.9154 22 16.8039 21.2377C17.6925 20.4754 17.9547 19.1768 18.4791 16.5796L19 14'
            stroke-linecap='round'
        ></path>
    </svg>
)

export const Gift2Icon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M190.5 68.8L225.3 128l-1.3 0-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8zM64 88c0 14.4 3.5 28 9.6 40L32 128c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l448 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-41.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88zm336 0c0 22.1-17.9 40-40 40l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40zM32 288l0 176c0 26.5 21.5 48 48 48l144 0 0-224L32 288zM288 512l144 0c26.5 0 48-21.5 48-48l0-176-192 0 0 224z'></path>
    </svg>
)

export const Gift3Icon = () => (
    <svg
        width='132.2173mm'
        height='128.68407mm'
        viewBox='0 0 132.2173 128.68407'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g id='layer1' transform='translate(-16.104392,-85.303735)'>
            <g id='g1'>
                <path
                    d='m 135.21607,190.48095 c -2.71724,-0.81312 -5.0208,-4.08243 -5.0208,-7.12571 0,-3.78262 2.9336,-6.77481 6.89437,-7.03206 6.68805,-0.43438 10.2989,7.05106 5.80223,12.0283 -2.07083,2.29216 -4.69723,3.02079 -7.6758,2.12947 z'
                    style='display:inline;fill:#955aa3;stroke-width:1'
                    id='path1-5'
                />
                <path
                    style='display:inline;fill:#efc318'
                    d='m 37.923875,208.09664 c -5.242448,-4.36409 -16.272669,-15.67889 -17.947462,-18.4105 -0.313181,-0.51081 0.389632,-1.75602 2.079937,-6.92391 2.045086,-6.25258 5.456587,-15.81596 7.673094,-21.50979 l 1.370052,-3.51943 2.28771,3.38793 c 4.983638,7.38039 9.348134,12.61488 16.287265,19.53387 6.899216,6.8792 13.685613,11.52076 20.396278,15.88825 1.309688,0.85238 2.743003,1.83299 2.803637,1.87391 0.254793,0.17197 -0.840732,0.24765 -7.866965,2.88837 -5.464824,2.05389 -24.02079,8.76685 -24.259333,9.10556 -0.01461,0.0207 -1.296244,-1.0423 -2.824213,-2.31426 z m 50.006996,-20.49586 c -9.51448,-5.46802 -16.8963,-11.79434 -25.268455,-20.18488 -8.929582,-8.9492 -16.207395,-18.46006 -21.492487,-28.08701 l -1.33088,-2.42425 3.23708,-6.57159 c 1.780394,-3.61437 3.705975,-7.37084 4.27907,-8.34771 l 1.483429,-2.39412 0.01981,1.77611 c 0.07782,6.97722 8.696085,21.2324 22.130156,34.97273 10.574727,10.81581 20.486403,18.40821 29.182226,22.55649 3.75315,1.79041 6.00373,2.62583 8.07943,2.49685 0.8253,-0.0513 1.9686,-0.44698 1.9684,-0.42158 -0.003,0.33284 -17.324645,9.62959 -17.977325,9.62959 -0.129495,0 -1.650928,-1.394 -3.686169,-2.56366 z m 10.320025,-65.68925 c -0.785124,-0.83573 -0.801218,-2.0463 -0.03974,-2.98885 3.698954,-4.57847 5.646524,-7.97075 6.801144,-11.84628 0.56463,-1.89517 0.70958,-2.94306 0.72973,-5.27536 0.0377,-4.367215 -1.01522,-7.647889 -3.6516,-11.377079 -1.43699,-2.032655 -1.59147,-2.550768 -1.06439,-3.570018 0.49487,-0.956979 1.49888,-1.415548 2.57958,-1.178188 1.50816,0.331249 4.61836,5.484623 5.90751,9.788345 0.59558,1.988291 0.71322,2.898746 0.7333,5.67549 0.0252,3.48499 -0.23969,5.14844 -1.34823,8.46666 -1.28688,3.85205 -4.04448,8.58902 -6.66161,11.44323 -1.2197,1.33019 -1.51883,1.52135 -2.380649,1.52135 -0.708419,0 -1.159883,-0.18544 -1.605048,-0.6593 z'
                    id='path6'
                />
                <path
                    style='display:inline;fill:#fd5262'
                    d='m 23.406649,213.8425 c -2.860581,-0.58929 -5.161684,-2.3605 -6.439889,-4.9569 -0.782217,-1.58891 -0.870078,-1.9991 -0.861883,-4.02379 0.0077,-1.89233 0.230736,-3.0482 1.388568,-7.19485 0.758694,-2.71718 1.649758,-5.80344 1.980145,-6.85836 l 0.600701,-1.91803 1.762706,2.13063 c 4.544204,5.4927 9.958934,10.96098 15.888441,16.04563 1.70987,1.46624 3.108854,2.74483 3.108854,2.84131 0,0.0965 -0.446484,0.29716 -0.992187,0.44598 -0.545704,0.14881 -3.593256,0.9896 -6.77234,1.86841 -6.207902,1.71608 -7.855659,1.99232 -9.663116,1.61997 z m 47.45785,-16.02641 c -0.727604,-0.50907 -2.041202,-1.35422 -2.244686,-1.47346 -0.866185,-0.50757 1.835408,-10.40044 3.966062,-15.90641 0.774517,-2.00148 0.760093,-3.6 0.974791,-3.44067 0.168528,0.12507 1.517322,1.6377 2.463207,2.36947 3.849702,2.97826 9.435542,6.65129 14.236087,9.36111 1.354171,0.7644 2.366202,1.48135 2.248958,1.59322 -0.491935,0.46939 -19.594017,8.47677 -20.126721,8.4369 -0.10713,-0.008 -0.790094,-0.43109 -1.517698,-0.94016 z m -2.203212,-1.45131 c -7.024893,-0.59406 -38.904513,-36.29121 -37.351985,-38.9507 0.219361,-0.37577 3.549837,-9.14389 5.952258,-14.60262 0.83258,-1.89177 1.749386,-3.97537 2.037346,-4.63021 l 0.523563,-1.19062 0.670274,1.32291 c 1.082577,2.13668 16.363321,23.98787 19.117092,25.71271 l 13.871345,12.97536 -0.358889,3.92748 c -0.290206,3.17585 -3.861572,10.05306 -3.861572,14.73553 0,0.68645 1.21396,0.6279 1.077992,0.71193 -0.135968,0.084 -0.113763,0.12047 -1.677424,-0.0118 z M 128.01451,164.5846 c -1.59062,-0.91222 -1.60934,-2.36633 -0.053,-4.11867 2.19308,-2.46929 3.09571,-4.68535 3.09571,-7.60031 0,-3.33959 -1.22383,-5.85551 -4.22593,-8.68754 -2.27557,-2.14666 -4.0353,-2.88875 -6.88657,-2.9041 -1.78101,-0.01 -2.21955,0.0998 -4.27918,1.06745 -1.26215,0.59298 -2.86949,1.46577 -3.57188,1.93953 -0.70238,0.47377 -4.96948,4.53122 -9.48245,9.01656 -9.021852,8.96663 -9.139931,9.05266 -10.664159,7.77011 -0.657064,-0.55288 -0.841908,-0.9161 -0.841908,-1.65435 0,-0.85621 0.314157,-1.26344 3.312037,-4.29326 2.633414,-3.32168 5.62052,-5.65361 8.70611,-8.6842 5.63703,-5.56319 7.47287,-6.95174 11.27263,-8.52615 5.81356,-2.40881 11.41142,-1.2477 15.88306,3.29446 3.32956,3.38207 4.73291,5.96187 5.3181,9.77631 0.59929,3.90636 -1.20839,9.15664 -4.255,12.35831 -1.54461,1.62323 -2.22519,1.87804 -3.32756,1.24583 z'
                    id='path4'
                />
                <path
                    style='display:inline;fill:#955aa3'
                    d='m 52.434326,183.3895 h -4.7e-5 z m -14.799565,10.79743 c -1.490096,-0.78609 -2.346424,-2.22838 -2.352366,-3.96204 -0.0051,-1.49304 0.46053,-2.50737 1.585674,-3.45412 1.734026,-1.45908 4.09244,-1.45009 5.842252,0.0223 2.423525,2.03926 1.936741,6.08243 -0.897491,7.45446 -1.486623,0.71966 -2.733315,0.70159 -4.178069,-0.0606 z m 30.319321,-53.92995 c -0.847268,-0.46342 -1.190625,-1.05298 -1.190625,-2.04436 0,-0.86262 0.62056,-1.55019 9.088273,-10.06975 11.35844,-11.42798 12.597431,-13.14726 12.823551,-17.79462 0.10435,-2.14466 0.0557,-2.42089 -0.717275,-4.0727 -0.612142,-1.30812 -1.399653,-2.3405 -3.008238,-3.94361 -2.78128,-2.771829 -4.22718,-3.412944 -7.73527,-3.429842 -2.198473,-0.01059 -2.533563,0.06131 -4.365624,0.93673 -1.091407,0.521512 -2.557163,1.444242 -3.257238,2.050522 -1.543399,1.33661 -2.738782,1.48035 -3.766247,0.45289 -1.080392,-1.0804 -0.889536,-2.14239 0.641661,-3.570421 3.753919,-3.501005 9.1204,-5.133677 13.682732,-4.162766 3.17112,0.674847 5.221633,1.849066 7.931826,4.542133 3.64208,3.619064 5.140181,6.726884 5.140181,10.663334 0,2.573 -0.574983,4.70676 -2.011495,7.46465 -1.958642,3.76029 -3.61168,5.59307 -17.241413,19.11614 -4.332985,4.29908 -4.738768,4.5596 -6.014799,3.86167 z'
                    id='path2'
                />
                <path
                    style='display:inline;fill:#d15526'
                    d='M 105.7895,181.19477 C 94.096798,178.52203 72.003287,160.10629 58.112482,141.45425 49.628184,130.06186 46.39082,120.89368 49.992465,118.45846 c 1.106402,-0.74808 4.142601,-0.70181 6.584535,0.10036 4.001821,1.31458 10.207485,4.87448 15.916521,9.13058 l 2.184175,1.62831 c -10.516531,11.50149 -8.564638,12.17919 3.564804,3.04271 0.759196,0 13.052346,11.96362 17.361824,16.89642 l 2.163676,2.47663 c -8.632144,9.70982 -7.662042,10.3398 2.94848,3.65878 0.0574,0.0656 0.93798,1.2503 1.95694,2.63275 7.31333,9.92221 10.73909,18.2108 8.95369,21.66338 -0.8085,1.56347 -3.05349,2.14279 -5.83761,1.50639 z'
                    id='path1'
                />
                <path
                    d='m 130.35405,126.69413 c -1.12463,-0.88466 -1.20154,-1.18601 -1.20154,-4.7087 0,-3.34438 0.11755,-3.87398 1.05542,-4.75507 1.44721,-1.35957 3.69014,-1.3036 5.12155,0.12772 0.9918,0.9918 1.11931,1.51367 1.11931,4.58089 0,3.06724 -0.12754,3.5891 -1.11931,4.58089 -1.38466,1.38467 -3.34911,1.45343 -4.97543,0.1742 z m -11.85643,-11.85644 c -1.28489,-1.01069 -1.63599,-3.31922 -0.75515,-4.9651 0.90723,-1.69516 6.26006,-2.47317 8.66016,-1.25871 2.50607,1.26809 2.91229,4.30836 0.8343,6.24429 -1.4479,1.34893 -7.01497,1.33589 -8.73931,-0.0205 z m 19.52651,-0.17418 c -1.44963,-1.44962 -1.45695,-3.45348 -0.0188,-5.12549 1.02409,-1.19056 1.33841,-1.27948 4.52343,-1.27948 2.99496,0 3.57,0.13823 4.59965,1.10554 1.56875,1.47377 1.59359,3.76331 0.0576,5.29943 -0.99181,0.99181 -1.51368,1.11931 -4.5809,1.11931 -3.06724,0 -3.58911,-0.12754 -4.58089,-1.11931 z m -6.90374,-7.09217 c -1.49968,-0.60424 -1.96788,-1.88944 -1.96788,-5.40174 0,-3.89557 0.20581,-4.474623 1.90212,-5.35183 1.52265,-0.787376 2.8584,-0.52552 4.36813,0.8563 0.8942,0.818434 1.02417,1.382993 1.01154,4.39374 -0.0155,3.57759 -0.37634,4.50269 -2.12161,5.43223 -1.1527,0.61393 -1.8091,0.6286 -3.1923,0.0713 z'
                    style='display:inline;fill:#955aa3;stroke-width:1'
                    id='path1-9'
                />
                <path
                    d='m 37.881234,111.8254 c -1.438287,-0.85446 -1.732611,-1.63798 -1.745263,-4.64606 -0.01033,-2.43787 0.125926,-3.10188 0.77959,-3.8036 1.657218,-1.77881 4.234035,-1.43588 5.369849,0.71462 0.787546,1.49111 0.454765,6.04427 -0.512444,7.01148 -0.973586,0.9736 -2.875614,1.32722 -3.891732,0.72356 z M 27.725726,101.6538 c -2.002813,-1.14862 -2.382731,-3.625858 -0.798958,-5.209636 0.845417,-0.845431 1.300861,-0.95875 3.85329,-0.95875 3.554109,0 4.952891,0.826328 4.952891,2.925886 0,1.84453 -0.326167,2.4891 -1.590313,3.14282 -1.307091,0.67593 -5.303875,0.73801 -6.41691,0.0996 z m 17.002765,-0.0279 c -2.111053,-1.0682 -2.489466,-3.662839 -0.783073,-5.369236 1.140936,-1.140937 6.49214,-1.126558 7.723631,0.02067 1.71745,1.600062 1.36254,4.298036 -0.702823,5.342716 -1.254034,0.63431 -4.988765,0.63777 -6.237735,0.006 z m -7.795392,-7.560261 c -0.65359,-0.830889 -0.809543,-1.586814 -0.809543,-3.923723 0,-2.552429 0.113377,-3.007873 0.958735,-3.85329 1.611704,-1.611704 4.128068,-1.192428 5.227005,0.870912 1.105314,2.075313 0.243939,7.0922 -1.320791,7.692644 -1.514418,0.581134 -3.243353,0.245814 -4.055406,-0.786543 z'
                    style='display:inline;fill:#3b96d2;stroke-width:1'
                    id='path1-7'
                />
            </g>
        </g>
    </svg>
)

export const SupportIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='none'
        color='currentColor'
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M3.91826 9.55404C4.53058 9.07788 5.33022 9.04746 5.96627 9.36548L6.89443 9.82956C7.572 10.1683 8 10.8609 8 11.6184V16.3823C8 17.1399 7.572 17.8324 6.89443 18.1712L5.96627 18.6353C5.33022 18.9533 4.53058 18.9229 3.91826 18.4467C3.46838 18.0969 2.77042 17.5054 2.17589 16.7789C1.60362 16.0797 1 15.1026 1 14.0004C1 12.8982 1.60362 11.9211 2.17589 11.2218C2.77042 10.4954 3.46838 9.90388 3.91826 9.55404Z'
            fill='currentColor'
        ></path>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M12 3C8.13401 3 5 6.13401 5 10V10.5C5 11.0523 4.55228 11.5 4 11.5C3.44772 11.5 3 11.0523 3 10.5V10C3 5.02944 7.02944 1 12 1C16.9706 1 21 5.02944 21 10V10.5C21 11.0523 20.5523 11.5 20 11.5C19.4477 11.5 19 11.0523 19 10.5V10C19 6.13401 15.866 3 12 3Z'
            fill='currentColor'
        ></path>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M20 16.5C20.5523 16.5 21 16.9477 21 17.5V18C21 20.7614 18.7614 23 16 23H12C11.4477 23 11 22.5523 11 22C11 21.4477 11.4477 21 12 21H16C17.6569 21 19 19.6569 19 18V17.5C19 16.9477 19.4477 16.5 20 16.5Z'
            fill='currentColor'
        ></path>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M18.0337 9.36548C18.6698 9.04746 19.4694 9.07788 20.0817 9.55404C20.5316 9.90388 21.2296 10.4954 21.8241 11.2218C22.3964 11.9211 23 12.8982 23 14.0004C23 15.1026 22.3964 16.0797 21.8241 16.7789C21.2296 17.5054 20.5316 18.0969 20.0817 18.4467C19.4694 18.9229 18.6698 18.9533 18.0337 18.6353L17.1056 18.1712C16.428 17.8324 16 17.1399 16 16.3823V11.6184C16 10.8609 16.428 10.1683 17.1056 9.82956L18.0337 9.36548Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const RequestOwnershipIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='none'
        color='currentColor'
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M8.95499 1.6618C10.908 1.61273 12.842 1.61273 14.795 1.66181L14.8532 1.66327C16.378 1.70156 17.605 1.73237 18.5883 1.90362C19.6178 2.08291 20.4545 2.42679 21.1614 3.13634C21.8653 3.84292 22.2074 4.66761 22.3832 5.68042C22.5507 6.64479 22.5762 7.84183 22.6078 9.32467L22.6091 9.3834C22.6303 10.3797 22.6303 11.3703 22.6091 12.3666L22.6078 12.4255L22.6078 12.4258C22.5931 13.1145 22.5798 13.7416 22.5529 14.3124C22.5412 14.5591 22.5354 14.6825 22.4788 14.7568C22.4567 14.7858 22.4405 14.8012 22.4106 14.8219C22.3336 14.875 22.1808 14.875 21.875 14.875H20.975C20.6922 14.875 20.5507 14.875 20.4629 14.7871C20.375 14.6993 20.375 14.5578 20.375 14.275V13.375C20.375 11.9943 19.2557 10.875 17.875 10.875C16.4943 10.875 15.375 11.9943 15.375 13.375V14.275C15.375 14.5578 15.375 14.6993 15.2871 14.7871C15.1993 14.875 15.0578 14.875 14.775 14.875H13.875C12.4943 14.875 11.375 15.9943 11.375 17.375V19.5213C11.375 19.8056 11.375 19.9477 11.2861 20.0358C11.1972 20.1238 11.0556 20.1224 10.7724 20.1197C10.1677 20.114 9.56226 20.1035 8.95499 20.0882L8.89677 20.0867C7.37197 20.0485 6.14501 20.0176 5.1617 19.8464C4.1322 19.6671 3.29548 19.3232 2.58862 18.6137C1.88472 17.9071 1.54264 17.0824 1.36676 16.0696C1.19929 15.1052 1.17379 13.9082 1.14219 12.4254L1.14094 12.3666C1.11969 11.3703 1.11969 10.3797 1.14093 9.38339L1.14219 9.32465C1.17378 7.8418 1.19929 6.64478 1.36676 5.6804C1.54264 4.6676 1.88471 3.8429 2.58862 3.13632C3.29548 2.42677 4.1322 2.08289 5.1617 1.9036C6.14502 1.73235 7.372 1.70155 8.89682 1.66326L8.95499 1.6618ZM7.25682 6.72939C6.90027 6.51858 6.44033 6.63674 6.22952 6.99329C6.01871 7.34985 6.13686 7.80979 6.49341 8.0206L9.43543 9.76003C10.3063 10.2749 11.0577 10.625 11.8751 10.625C12.6925 10.625 13.444 10.2749 14.3148 9.76003L17.2568 8.0206C17.6134 7.80979 17.7315 7.34985 17.5207 6.99329C17.3099 6.63674 16.85 6.51858 16.4934 6.72939L13.5514 8.46882C12.707 8.96804 12.2581 9.125 11.8751 9.125C11.4921 9.125 11.0432 8.96804 10.1988 8.46882L7.25682 6.72939Z'
            fill='currentColor'
        ></path>
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M17.875 12.375C18.4273 12.375 18.875 12.8227 18.875 13.375V16.375H21.875C22.4273 16.375 22.875 16.8227 22.875 17.375C22.875 17.9273 22.4273 18.375 21.875 18.375H18.875V21.375C18.875 21.9273 18.4273 22.375 17.875 22.375C17.3227 22.375 16.875 21.9273 16.875 21.375V18.375H13.875C13.3227 18.375 12.875 17.9273 12.875 17.375C12.875 16.8227 13.3227 16.375 13.875 16.375H16.875L16.875 13.375C16.875 12.8227 17.3227 12.375 17.875 12.375Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const FeedbackIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 16 16'
        height='1em'
        width='1em'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M8 15c4.418 0 8-3.134 8-7s-3.582-7-8-7-8 3.134-8 7c0 1.76.743 3.37 1.97 4.6-.097 1.016-.417 2.13-.771 2.966-.079.186.074.394.273.362 2.256-.37 3.597-.938 4.18-1.234A9 9 0 0 0 8 15m0-9.007c1.664-1.711 5.825 1.283 0 5.132-5.825-3.85-1.664-6.843 0-5.132'></path>
    </svg>
)

export const BirthDayCakeIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 448 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M448 384c-28.02 0-31.26-32-74.5-32-43.43 0-46.825 32-74.75 32-27.695 0-31.454-32-74.75-32-42.842 0-47.218 32-74.5 32-28.148 0-31.202-32-74.75-32-43.547 0-46.653 32-74.75 32v-80c0-26.5 21.5-48 48-48h16V112h64v144h64V112h64v144h64V112h64v144h16c26.5 0 48 21.5 48 48v80zm0 128H0v-96c43.356 0 46.767-32 74.75-32 27.951 0 31.253 32 74.75 32 42.843 0 47.217-32 74.5-32 28.148 0 31.201 32 74.75 32 43.357 0 46.767-32 74.75-32 27.488 0 31.252 32 74.5 32v96zM96 96c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40zm128 0c-17.75 0-32-14.25-32-32 0-31 32-23 32-64 12 0 32 29.5 32 56s-14.25 40-32 40z'></path>
    </svg>
)

export const WalletIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M95.5 104h320a87.73 87.73 0 0 1 11.18.71 66 66 0 0 0-77.51-55.56L86 94.08h-.3a66 66 0 0 0-41.07 26.13A87.57 87.57 0 0 1 95.5 104zm320 24h-320a64.07 64.07 0 0 0-64 64v192a64.07 64.07 0 0 0 64 64h320a64.07 64.07 0 0 0 64-64V192a64.07 64.07 0 0 0-64-64zM368 320a32 32 0 1 1 32-32 32 32 0 0 1-32 32z'></path>
        <path d='M32 259.5V160c0-21.67 12-58 53.65-65.87C121 87.5 156 87.5 156 87.5s23 16 4 16-18.5 24.5 0 24.5 0 23.5 0 23.5L85.5 236z'></path>
    </svg>
)

export const LogoutIcon = () => (
    <svg
        stroke='currentColor'
        fill='none'
        stroke-width='2'
        viewBox='0 0 24 24'
        stroke-linecap='round'
        stroke-linejoin='round'
        height={25}
        width={25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4'></path>
        <polyline points='16 17 21 12 16 7'></polyline>
        <line x1='21' x2='9' y1='12' y2='12'></line>
    </svg>
)

export const SettingIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='none'
        xmlns:xlink='http://www.w3.org/1999/xlink'
        color='currentColor'
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M10.7224 1.25C9.96916 1.25 9.30042 1.732 9.06222 2.4466L8.37472 4.5091L7.31134 5.18166L5.06975 4.62702C4.32099 4.44175 3.53922 4.76857 3.1451 5.43163L1.78091 7.72672C1.35069 8.45051 1.4969 9.37806 2.12889 9.93442L3.6646 11.2863V12.7137L2.12936 14.0656C1.49752 14.622 1.35141 15.5494 1.78157 16.2732L3.14583 18.5684C3.53994 19.2314 4.32171 19.5582 5.07048 19.373L7.33457 18.8128L8.28531 19.3459L8.90518 21.4867C9.12185 22.235 9.80709 22.75 10.5861 22.75H13.4179C14.197 22.75 14.8822 22.235 15.0989 21.4867L15.7188 19.3458L16.6688 18.8128L18.9328 19.373C19.6816 19.5582 20.4634 19.2314 20.8575 18.5684L22.2475 16.2298C22.6571 15.5406 22.5461 14.6612 21.9779 14.0955L20.3927 12.5172L20.3931 11.4831L21.9786 9.90447C22.5468 9.33878 22.6579 8.45936 22.2482 7.77018L20.8582 5.43163C20.4641 4.76857 19.6823 4.44175 18.9336 4.62702L16.692 5.18166L15.6286 4.5091L14.9411 2.4466C14.7029 1.732 14.0341 1.25 13.2809 1.25L10.7224 1.25ZM12 15.5C13.933 15.5 15.5 13.933 15.5 12C15.5 10.067 13.933 8.5 12 8.5C10.067 8.5 8.5 10.067 8.5 12C8.5 13.933 10.067 15.5 12 15.5Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const LoginIcon = () => (
    <svg
        stroke='currentColor'
        fill='none'
        stroke-width='2'
        viewBox='0 0 24 24'
        stroke-linecap='round'
        stroke-linejoin='round'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4'></path>
        <polyline points='10 17 15 12 10 7'></polyline>
        <line x1='15' y1='12' x2='3' y2='12'></line>
    </svg>
)

export const CalenderIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M480 128a64 64 0 00-64-64h-16V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00368 48v16H144V48.45c0-8.61-6.62-16-15.23-16.43A16 16 0 00112 48v16H96a64 64 0 00-64 64v12a4 4 0 004 4h440a4 4 0 004-4zM32 416a64 64 0 0064 64h320a64 64 0 0064-64V179a3 3 0 00-3-3H35a3 3 0 00-3 3zm344-208a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24zm-80-80a24 24 0 11-24 24 24 24 0 0124-24zm0 80a24 24 0 11-24 24 24 24 0 0124-24z'></path>
    </svg>
)

export const TrashIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        width={25}
        height={25}
        stroke-width='0'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path fill='none' d='M0 0h24v24H0z'></path>
        <path d='M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z'></path>
    </svg>
)

export const TrashIconStroke = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 16 16'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M14 2H10C10 0.897 9.103 0 8 0C6.897 0 6 0.897 6 2H2C1.724 2 1.5 2.224 1.5 2.5C1.5 2.776 1.724 3 2 3H2.54L3.349 12.708C3.456 13.994 4.55 15 5.84 15H10.159C11.449 15 12.543 13.993 12.65 12.708L13.459 3H13.999C14.275 3 14.499 2.776 14.499 2.5C14.499 2.224 14.275 2 13.999 2H14ZM8 1C8.551 1 9 1.449 9 2H7C7 1.449 7.449 1 8 1ZM11.655 12.625C11.591 13.396 10.934 14 10.16 14H5.841C5.067 14 4.41 13.396 4.346 12.625L3.544 3H12.458L11.656 12.625H11.655ZM7 5.5V11.5C7 11.776 6.776 12 6.5 12C6.224 12 6 11.776 6 11.5V5.5C6 5.224 6.224 5 6.5 5C6.776 5 7 5.224 7 5.5ZM10 5.5V11.5C10 11.776 9.776 12 9.5 12C9.224 12 9 11.776 9 11.5V5.5C9 5.224 9.224 5 9.5 5C9.776 5 10 5.224 10 5.5Z'></path>
    </svg>
)

export const ResetIcon: Component = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        stroke-width='2'
        stroke-linecap='round'
        stroke-linejoin='round'
        width={25}
        height={25}
    >
        <path d='M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8' />
        <path d='M3 3v5h5' />
    </svg>
)

export const IpAddressIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM288 176c0-44.2-35.8-80-80-80s-80 35.8-80 80c0 48.8 46.5 111.6 68.6 138.6c6 7.3 16.8 7.3 22.7 0c22.1-27 68.6-89.8 68.6-138.6zm-112 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z'></path>
    </svg>
)

export const DescriptionIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 16 16'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H4.414a1 1 0 0 0-.707.293L.854 15.146A.5.5 0 0 1 0 14.793V2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1h-9zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1h-5z'></path>
    </svg>
)

export const ArrowDownIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M256 294.1L383 167c9.4-9.4 24.6-9.4 33.9 0s9.3 24.6 0 34L273 345c-9.1 9.1-23.7 9.3-33.1.7L95 201.1c-4.7-4.7-7-10.9-7-17s2.3-12.3 7-17c9.4-9.4 24.6-9.4 33.9 0l127.1 127z'></path>
    </svg>
)

export const SearchIcon = () => (
    <svg
        style={{ transform: 'scaleX(-1)' }}
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z'></path>
    </svg>
)

export const LocationSearchIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        viewBox='0 0 24 24'
        width='25'
        height='25'
        color='currentColor'
        fill='none'
        stroke='currentColor'
        stroke-width='1.5'
        stroke-linecap='round'
    >
        <path d='M14.9961 9.19621C14.3836 8.17979 13.2693 7.5 11.9961 7.5C10.0631 7.5 8.49609 9.067 8.49609 11C8.49609 12.2732 9.17588 13.3876 10.1923 14' />
        <path
            d='M20.9961 20.5L18.849 18.3529M18.849 18.3529C18.9636 18.2384 19.07 18.1158 19.1675 17.986C19.5981 17.413 19.8532 16.7006 19.8532 15.9286C19.8532 14.035 18.3182 12.5 16.4247 12.5C14.5311 12.5 12.9961 14.035 12.9961 15.9286C12.9961 17.8221 14.5311 19.3571 16.4247 19.3571C17.3714 19.3571 18.2286 18.9734 18.849 18.3529Z'
            stroke-linejoin='round'
        />
        <path d='M20.983 11C21.0565 9.86816 20.8623 8.66581 20.3121 7.37966C18.9087 4.09916 15.54 2 11.9972 2C8.45444 2 5.08573 4.09916 3.68236 7.37966C1.08686 13.4469 6.40912 17.626 10.3806 21.367C10.8143 21.773 11.3939 22 11.9972 22' />
    </svg>
)

export const ReverseSearchIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 24 24'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M18.031 16.6168L22.3137 20.8995L20.8995 22.3137L16.6168 18.031C15.0769 19.263 13.124 20 11 20C6.032 20 2 15.968 2 11C2 6.032 6.032 2 11 2C15.968 2 20 6.032 20 11C20 13.124 19.263 15.0769 18.031 16.6168ZM16.0247 15.8748C17.2475 14.6146 18 12.8956 18 11C18 7.1325 14.8675 4 11 4C7.1325 4 4 7.1325 4 11C4 14.8675 7.1325 18 11 18C12.8956 18 14.6146 17.2475 15.8748 16.0247L16.0247 15.8748Z'></path>
    </svg>
)

export const HistoryIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 16 16'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M13.507 12.324a7 7 0 0 0 .065-8.56A7 7 0 0 0 2 4.393V2H1v3.5l.5.5H5V5H2.811a6.008 6.008 0 1 1-.135 5.77l-.887.462a7 7 0 0 0 11.718 1.092zm-3.361-.97l.708-.707L8 7.792V4H7v4l.146.354 3 3z'
        ></path>
    </svg>
)

export const EyeIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <circle cx='256' cy='256' r='64'></circle>
        <path d='M490.84 238.6c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.66 96c-42.52 0-84.33 12.15-124.27 36.11-40.73 24.43-77.63 60.12-109.68 106.07a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.4 76.14 98.28 100.65C162 402 207.9 416 255.66 416c46.71 0 93.81-14.43 136.2-41.72 38.46-24.77 72.72-59.66 99.08-100.92a32.2 32.2 0 0 0-.1-34.76zM256 352a96 96 0 1 1 96-96 96.11 96.11 0 0 1-96 96z'></path>
    </svg>
)
export const EyeShutIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M432 448a15.92 15.92 0 0 1-11.31-4.69l-352-352a16 16 0 0 1 22.62-22.62l352 352A16 16 0 0 1 432 448zM248 315.85l-51.79-51.79a2 2 0 0 0-3.39 1.69 64.11 64.11 0 0 0 53.49 53.49 2 2 0 0 0 1.69-3.39zm16-119.7L315.87 248a2 2 0 0 0 3.4-1.69 64.13 64.13 0 0 0-53.55-53.55 2 2 0 0 0-1.72 3.39z'></path>
        <path d='M491 273.36a32.2 32.2 0 0 0-.1-34.76c-26.46-40.92-60.79-75.68-99.27-100.53C349 110.55 302 96 255.68 96a226.54 226.54 0 0 0-71.82 11.79 4 4 0 0 0-1.56 6.63l47.24 47.24a4 4 0 0 0 3.82 1.05 96 96 0 0 1 116 116 4 4 0 0 0 1.05 3.81l67.95 68a4 4 0 0 0 5.4.24 343.81 343.81 0 0 0 67.24-77.4zM256 352a96 96 0 0 1-93.3-118.63 4 4 0 0 0-1.05-3.81l-66.84-66.87a4 4 0 0 0-5.41-.23c-24.39 20.81-47 46.13-67.67 75.72a31.92 31.92 0 0 0-.64 35.54c26.41 41.33 60.39 76.14 98.28 100.65C162.06 402 207.92 416 255.68 416a238.22 238.22 0 0 0 72.64-11.55 4 4 0 0 0 1.61-6.64l-47.47-47.46a4 4 0 0 0-3.81-1.05A96 96 0 0 1 256 352z'></path>
    </svg>
)

export const SocialWorkingIcon = () => (
    <svg
        width='144.02208mm'
        height='134.72037mm'
        viewBox='0 0 144.02208 134.72037'
        version='1.1'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g id='g166' transform='translate(-34.629506,-58.063985)'>
            <path
                style='display:inline;fill:#dbe4f0'
                d='m 78.982764,173.18607 v -15.38111 h 28.363336 28.36333 v 7.31941 c 0,4.24328 0.11975,7.63438 0.28495,8.06887 0.16251,0.42745 0.64756,0.88635 1.12889,1.06803 0.82885,0.31286 0.84394,0.35466 0.84394,2.3391 0,1.95869 -0.0248,2.03083 -0.81006,2.35609 -1.23797,0.51278 -1.44772,1.33471 -1.44772,5.67289 v 3.93783 H 107.3461 78.982764 Z m -18.006044,-24.13 c 0.0521,-0.68929 -0.15029,-1.19458 -0.673838,-1.68234 -0.590334,-0.54998 -1.487841,-0.0463 -8.854722,-0.0463 h -7.707895 v -14.49917 -13.97 l 16.01953,-0.52917 19.19453,-0.52916 2.430748,1.29308 2.430747,1.29309 v 2.94323 c 0,5.80951 1.397995,12.59396 4.969124,17.39523 0.81059,1.08981 1.742947,2.22012 2.071897,2.51179 l 0.598096,0.53032 -1.120809,1.2733 c -0.616447,0.70032 -1.120808,1.38243 -1.120808,1.5158 0,0.13337 -7.506769,1.06226 -12.783384,0.77166 l -9.608383,-0.52917 -0.692728,0.69272 c -0.381,0.381 -0.692727,0.87933 -0.692727,1.1074 0,0.32209 -0.498998,0.43522 -2.235021,0.50672 -1.229262,0.0506 -2.230222,0.0285 -2.224357,-0.0491 z m 64.56956,-2.13524 c -0.31808,-0.51468 -0.83251,-1.16579 -1.14314,-1.44691 -0.5604,-0.50716 -1.08461,-1.05153 0.10925,-2.48616 8.12011,-9.75771 7.67384,-20.63632 7.28013,-23.03586 l -0.26626,-1.62277 h 20.59478 17.41978 v 14.49917 13.97 l -20.1206,0.52917 -23.29559,0.52916 z'
                id='path174'
            />
            <path
                style='display:inline;fill:#f9c997'
                d='m 105.40903,172.30092 c -1.65387,-1.65387 -0.4105,-4.61818 1.93707,-4.61818 2.34757,0 3.59093,2.96431 1.93707,4.61818 -0.56923,0.56923 -1.02435,0.74404 -1.93707,0.74404 -0.91273,0 -1.36785,-0.17481 -1.93707,-0.74404 z m -2.54321,-26.27855 c -9.943906,0 -16.263056,-11.86554 -16.263056,-21.52709 l -1.5875,-4.57384 1.905,0.13389 c 1.749732,0.12298 8.904374,-0.21717 11.583143,-0.67425 0.948765,-0.16189 1.080599,-0.12339 0.929132,0.27132 -0.295069,0.76894 1.420431,-3.36732 2.364631,-2.79897 2.18549,1.31554 5.22626,7.63971 9.723,8.20202 3.1674,0.39608 6.28534,-1.10513 7.63556,-1.20555 0.94807,-3.2e-4 7.17171,-1.07028 9.45016,-1.99875 1.13235,-0.46143 2.09057,-0.83941 2.12937,-0.83994 0.0388,-5.3e-4 0.0683,0.60228 0.0657,1.33959 -0.0113,3.07957 -2.97807,10.60929 -4.91468,13.67946 -2.13079,3.37801 -6.25551,6.86188 -9.85645,8.32507 -3.64449,1.4809 -9.39594,1.66704 -13.16397,1.66704 z M 69.104987,132.85798 c -2.173095,-1.12018 -1.945998,-5.46388 0.490681,-5.48877 1.133014,-0.0116 3.425153,1.70174 3.425153,2.80072 0,1.63377 -2.498788,3.4185 -3.915834,2.68805 z m 72.667133,0.0846 c -1.56189,-0.646 -1.95695,-3.64919 -0.76782,-4.83831 1.27363,-1.27363 4.18446,0.16901 4.81922,1.83855 0.72435,1.90518 -2.19303,3.76838 -4.0514,2.99976 z m -78.519796,-24.7351 c -3.734884,0 -9.197001,-8.657707 -11.135042,-14.819739 l -0.377241,-1.728611 1.327057,-0.01877 c 0.729881,-0.01032 2.501806,-0.173364 3.937612,-0.362317 l 12.739295,-3.854542 c 2.038679,-1.024957 2.244995,-1.074223 2.963333,-0.70761 0.424651,0.216726 1.678405,0.683901 2.78612,1.038165 2.933194,1.001243 8.793762,0.45604 11.601204,1.722586 l 3.596346,1.622451 -1.160024,3.118886 C 87.861222,98.707364 83.246538,105.55803 78.7158,106.71901 l -2.691281,1.15596 -2.102235,1.61773 c -1.54037,1.18535 -7.461889,-1.28522 -10.669963,-1.28522 z m 73.339056,-0.0822 c -2.94242,-0.86453 -3.81,-1.33455 -3.81,-2.06408 0,-2.18523 -5.94108,-11.882127 -7.8386,-14.331514 l -0.98386,-1.27 1.21859,-0.199796 c 0.67022,-0.109887 7.91784,0.263704 8.3447,0.183445 0.69666,-0.130988 0.0842,0.80135 0.77611,0.644489 2.57969,-0.584808 2.50966,-1.775233 3.17272,-1.908478 1.18496,-0.23812 1.28859,-1.183441 1.92813,-0.280064 0.0956,0.13498 -12.66284,6.581686 3.26542,-1.423332 l 2.19249,-1.101873 1.56451,0.642672 c 0.86048,0.353469 2.1823,0.809122 2.93739,1.012562 1.35962,0.366315 -0.0538,0.40917 0.66493,0.740823 2.51998,1.162902 0.67503,-0.311542 2.71488,0.687774 0.72858,0.356928 -0.46321,-0.667524 0.35278,-0.473994 0.45165,0.107121 4.0414,0.270147 6.03693,0.36228 l 3.62824,0.167514 -0.1792,1.120697 c -0.52149,3.261318 -2.28512,9.710135 -4.99996,12.456505 -1.46991,1.48697 -4.55989,2.69797 -6.63223,3.69243 -1.45297,0.69723 -3.31476,1.4054 -4.13732,1.57369 -2.2276,0.45577 -8.25778,0.3438 -10.21665,-0.23175 z'
                id='path172'
            />
            <path
                style='display:inline;fill:#39a4f3'
                d='m 92.036207,152.02571 c -0.482821,-0.81265 -1.164832,-1.46442 -1.164832,-1.70976 0,-0.24534 0.53975,-2.07315 1.199444,-2.7683 l 1.199444,-1.26391 4.016625,4.032 3.619752,3.60206 -4.183531,0.95911 h -2.992902 z m 26.489563,-2.22541 4.0082,-2.95994 1.06676,1.04166 c 1.44739,1.41334 1.44648,2.94649 -0.003,4.36233 l -2.12858,1.57423 h -2.94639 -2.94639 z M 56.783396,113.42552 c -1.337989,-1.42502 -1.357266,-1.78587 -0.163437,-3.05945 l 1.055028,-1.12551 2.534116,2.55109 2.534116,2.55109 H 60.19391 c -2.511337,0 -2.562136,-0.0137 -3.410514,-0.91722 z m 97.406924,-2.14731 2.52356,-2.53531 0.79703,0.7636 c 1.28933,1.23526 1.82908,2.4485 0.57867,3.72904 l -1.0811,1.10715 h -2.93545 -2.93546 z'
                id='path170'
            />
            <path
                style='display:inline;fill:#e49250'
                d='m 101.94153,150.60451 c -1.08554,-1.25445 -1.36115,-2.07978 -1.09314,-1.98695 2.21169,0.76607 10.74974,0.34351 13.70287,-0.3291 l 1.10211,-0.25102 -3.14115,4.21348 -2.612,2.62599 h -2.13079 -2.13079 z m 7.69762,-28.17631 c -2.14041,-0.22332 -4.93889,-1.29899 -4.93889,-1.49366 0,-0.0495 0.4445,-1.01748 0.98778,-2.15111 1.1556,-2.41134 1.18849,-2.73356 0.38353,-3.7569 -0.53377,-0.67858 -0.75594,-0.75465 -1.905,-0.6522 -0.71541,0.0638 -2.44205,0.46043 -3.83696,0.88142 -6.677372,2.01528 -15.487959,3.55813 -18.948591,0.3249 l -1.024594,-0.95727 0.19695,-1.7631 c 0.419082,-3.75163 2.230054,-7.71877 4.857698,-10.64134 2.298998,-2.557042 6.376221,-5.880003 9.807179,-6.87741 2.386763,-0.693851 1.956137,-1.228728 1.770373,-3.277366 -0.08266,-0.911567 0.954634,-3.971641 0.253343,-2.848019 -2.042063,3.271832 -0.853813,-1.176139 1.318914,-2.567425 2.967348,-1.900112 6.895928,5.108517 15.830228,6.426671 4.65174,0.686312 5.95822,0.983538 7.36424,1.675377 2.72356,1.340143 7.10165,6.628992 8.05018,10.891552 0.4975,2.23569 1.17102,8.22838 0.79429,11.00613 l -0.21702,1.60016 -2.45196,0.96937 c -3.16686,1.252 -8.83433,2.38301 -12.21486,2.71195 -1.49899,0.14586 -2.85244,0.25158 -3.00766,0.23494 -0.15522,-0.0166 -1.82739,0.39289 -3.06917,0.26333 z m -42.653,-9.53185 -0.889006,-0.91722 h 4.560065 4.560066 l -1.418173,1.44639 c -0.816714,0.83296 -1.832947,2.21993 -3.406476,2.17399 -1.593131,-0.0465 -5.285618,-1.98786 -3.406476,-2.70316 z m 72.81333,0.52917 -0.889,-1.44639 h 4.70117 4.70117 c -0.64911,0.48213 -3.54432,3.89262 -1.30241,1.82673 0.87315,-0.80459 -1.59921,1.39678 -3.33261,1.39678 -1.7334,0 -3.05195,-0.92451 -3.87832,-1.77712 z'
                id='path169'
            />
            <path
                style='display:inline;fill:#543737'
                d='m 49.706477,87.883332 c -0.969713,0 -0.239364,-7.72293 0.179091,-9.362591 2.612296,-10.23594 12.052812,-17.934042 22.418157,-17.367629 11.035585,0.603037 22.072229,11.369979 20.013632,21.954325 l -0.493477,2.537226 -1.834444,0.506176 c -4.334124,1.195909 -10.526333,0.39801 -15.689929,-2.021733 -1.347734,-0.631569 -2.655096,-1.147101 -2.905248,-1.145627 -0.250153,0.0015 -1.216823,0.485237 -2.148156,1.075027 -2.301587,1.457537 -6.04847,3.017494 -8.607777,3.583716 -1.169329,0.258702 -4.04101,0.535629 -6.416289,0.618746 -4.014073,0.140462 -3.982914,-0.377636 -4.515555,-0.377636 z M 122.5697,86.757306 c -0.26895,-2.152586 -0.51727,-6.899629 0.0323,-8.962341 1.78464,-6.697959 7.92037,-13.05474 14.61191,-15.16715 2.28431,-0.721119 2.98666,-1.274635 3.00209,-2.365906 0.009,-0.606982 0.1117,-0.634723 2.33731,-0.628892 l 2.32833,0.0061 0.42333,0.909265 c 0.38848,0.834421 0.63242,0.961562 2.96334,1.544604 7.68618,1.922575 14.17496,7.487535 16.30671,14.732755 0.66651,2.265283 0.56893,7.310012 0.24103,8.172433 -0.39744,1.045358 -2.87824,1.675433 -6.58928,1.67355 -3.57921,-0.0018 -7.46485,-0.914996 -10.90279,-2.562309 -1.29549,-0.620744 -2.57238,-1.128625 -2.83752,-1.128625 -0.26515,0 -1.08594,0.382952 -1.82398,0.851004 -4.89625,3.105106 -10.0224,4.510109 -16.45775,4.510832 l -3.43692,3.86e-4 z'
                id='path167'
            />
            <path
                style='fill:#010101'
                d='m 70.040659,192.51632 c -1.16505,-0.46941 -1.548273,-1.9349 -0.774389,-2.96136 0.350915,-0.46544 0.856713,-0.58919 2.883802,-0.70556 l 2.458248,-0.14111 0.141111,-16.13678 c 0.137683,-15.74472 0.155249,-16.15571 0.722994,-16.91589 1.316217,-1.76235 1.816795,-1.93503 5.898673,-2.03474 l 3.760332,-0.0919 0.876778,-1.09103 c 0.482228,-0.60007 0.876778,-1.16198 0.876778,-1.24869 0,-0.0867 -4.427872,-0.15766 -9.839717,-0.15766 -9.527237,0 -9.863332,-0.0186 -10.583333,-0.58493 -0.909799,-0.71565 -0.991271,-1.98964 -0.179171,-2.80174 0.544493,-0.54449 0.940741,-0.56444 11.210149,-0.56444 h 10.645705 l 1.61493,-1.59808 1.61493,-1.59808 -1.864072,-2.00026 c -5.064031,-5.43398 -7.30202,-11.31015 -7.093027,-18.62378 l 0.09916,-3.47013 -1.693333,-0.60711 c -1.664299,-0.59671 -1.994564,-0.60712 -19.261666,-0.60706 l -17.568333,5e-5 v 14.25223 14.25222 h 7.882063 c 8.377364,0 8.466671,0.0138 8.898858,1.3755 0.257601,0.81163 -0.322781,1.9912 -1.1309,2.29845 -1.094665,0.41619 -23.045748,0.36724 -23.969063,-0.0534 -1.136843,-0.51798 -1.395124,-2.12746 -0.501745,-3.12661 0.344215,-0.38497 0.896124,-0.49389 2.502614,-0.49389 h 2.06101 l 0.08247,-14.605 c 0.07988,-14.14675 0.100659,-14.63596 0.662173,-15.59182 0.318837,-0.54275 1.004368,-1.273 1.523403,-1.62278 0.844085,-0.56883 1.289334,-0.63607 4.218074,-0.63704 l 3.274375,-0.001 1.058334,-1.30784 c 0.68121,-0.8418 1.058333,-1.60065 1.058333,-2.12959 0,-1.15315 0.696799,-2.41092 2.187973,-3.94945 l 1.280606,-1.32128 -1.192902,-1.3552 c -2.371165,-2.69379 -4.19517,-6.7051 -4.823276,-10.607244 -0.318136,-1.976441 -0.413314,-2.187222 -0.987634,-2.187222 -1.813178,0 -2.727516,-2.894153 -2.719421,-8.607777 0.01085,-7.661132 3.186102,-14.344865 9.225353,-19.418893 2.353874,-1.977666 6.723762,-4.203537 9.870411,-5.027647 3.260959,-0.854049 8.683308,-0.863512 12.079492,-0.02108 11.27249,2.796161 19.388285,12.868649 19.388285,24.06274 0,1.386852 0.09525,2.517049 0.211667,2.511549 0.116416,-0.0055 0.529166,-0.191501 0.917222,-0.413333 1.167694,-0.667514 2.308525,-0.499205 4.108827,0.606183 3.57456,2.194787 4.83995,2.635989 10.30178,3.591898 2.24122,0.392251 4.88163,0.901653 5.86758,1.132003 l 1.79262,0.41882 -0.13817,-0.898897 c -0.94939,-6.176321 -0.93221,-8.643944 0.088,-12.639779 1.14036,-4.466355 3.33127,-8.288863 6.67293,-11.642354 3.43228,-3.444434 8.66118,-6.294821 12.11982,-6.606785 1.27098,-0.114641 1.49855,-0.05147 1.905,0.528822 0.55969,0.799074 0.58181,1.903343 0.0521,2.602261 -0.21534,0.284138 -1.38605,0.830569 -2.60158,1.21429 -6.69154,2.11241 -12.2981,7.940024 -14.08274,14.637983 -0.5496,2.062712 -0.83043,6.280589 -0.56148,8.433174 l 0.19812,1.585714 3.43692,-3.86e-4 c 6.43535,-7.22e-4 11.5615,-1.405726 16.45775,-4.510832 0.73804,-0.468052 1.55883,-0.851004 1.82398,-0.851004 0.26514,0 1.54203,0.507881 2.83752,1.128625 3.43794,1.647313 7.32358,2.560493 10.90279,2.562309 3.71104,0.0019 6.19184,-0.628192 6.58928,-1.67355 0.3279,-0.862421 -0.10369,-4.848816 -0.7702,-7.114099 -2.13003,-7.23936 -8.0733,-12.793265 -15.77013,-14.736981 -2.06738,-0.522086 -2.60672,-0.771644 -2.93617,-1.358602 -0.52702,-0.938944 -0.23085,-2.090529 0.69339,-2.696118 0.67161,-0.440052 0.86401,-0.439955 2.91821,0.0015 7.82138,1.680732 14.02111,6.584058 17.52099,13.857248 1.95784,4.068652 2.38128,5.974869 2.39063,10.762011 0.009,4.471062 -0.0593,4.658487 -1.9904,5.486263 l -1.15948,0.497013 -0.16908,2.395879 c -0.36078,5.112225 -2.45257,10.255998 -5.50132,13.527898 l -0.71483,0.76714 1.19444,1.29581 c 1.29134,1.40094 2.26455,3.25691 2.27445,4.3375 0.003,0.37207 0.4592,1.22932 1.01287,1.905 l 1.00668,1.22851 h 2.76159 c 3.13897,0 4.16122,0.4416 5.22869,2.25874 0.56151,0.95586 0.58229,1.44507 0.66217,15.59182 l 0.0825,14.605 h 2.06102 c 1.60649,0 2.15839,0.10892 2.50261,0.49389 0.89338,0.99915 0.6351,2.60863 -0.50175,3.12661 -0.53645,0.24443 -7.01707,0.33061 -24.86121,0.33061 h -24.13562 l 1.02106,1.24607 1.02106,1.24606 3.21154,0.0945 c 3.47317,0.10219 4.07583,0.33165 5.35003,2.03705 0.55197,0.73877 0.58612,1.20512 0.66442,9.07225 0.0799,8.03169 0.0644,8.31163 -0.49388,8.86987 -0.66927,0.66926 -1.92319,0.75081 -2.70972,0.17622 -0.51335,-0.37502 -0.55671,-0.89452 -0.68894,-8.255 L 135.85054,157.664 H 107.3461 78.841653 l -0.07296,15.45167 -0.07297,15.45166 h 28.647967 28.64796 v -4.18414 c 0,-4.00872 0.0274,-4.20986 0.65319,-4.79777 0.84459,-0.79345 1.91341,-0.78101 2.67639,0.0311 0.55532,0.59111 0.61228,0.99637 0.68419,4.86833 l 0.0785,4.22354 1.97556,0.0718 c 2.72967,0.0992 3.12607,0.22843 3.50479,1.14274 0.43627,1.05325 -0.007,2.23125 -0.9781,2.60054 -0.92687,0.3524 -73.670416,0.34554 -74.54546,-0.007 z m 29.544327,-39.1614 c 0,-0.11919 -1.342252,-1.54794 -2.982782,-3.175 l -2.982782,-2.95829 -1.10944,1.23574 c -0.610192,0.67966 -1.10944,1.50079 -1.10944,1.82475 0,0.32395 0.598475,1.19662 1.329946,1.93926 l 1.329946,1.35025 h 2.762276 c 1.519252,0 2.762276,-0.0975 2.762276,-0.21671 z m 12.565514,-2.07158 2.25115,-2.28828 -1.41111,0.24217 c -0.77611,0.1332 -3.06211,0.24218 -5.08,0.24218 -2.01789,0 -4.30389,-0.10898 -5.08,-0.24218 l -1.41111,-0.24217 2.25116,2.28828 2.25115,2.28829 h 1.9888 1.9888 z m 10.96142,0.88927 c 0.71974,-0.76946 1.30862,-1.60236 1.30862,-1.85087 0,-0.24852 -0.53975,-1.02056 -1.19944,-1.71564 l -1.19945,-1.26379 -3.09963,3.11466 -3.09963,3.11466 h 2.99045 2.99046 z m 46.18195,-19.34431 v -14.25223 h -18.19628 -18.19627 l 0.20461,0.91723 c 0.11254,0.50447 0.19338,2.75872 0.17965,5.00944 -0.0219,3.58304 -0.11875,4.40112 -0.77869,6.57481 -1.30584,4.30116 -3.41175,7.89902 -6.42734,10.98088 l -1.69085,1.72799 1.62986,1.64705 1.62987,1.64705 h 20.82272 20.82272 z m -28.33772,3.64821 c -2.62224,-0.96077 -4.40254,-3.46002 -4.3973,-6.17307 0.005,-2.83529 2.0946,-5.71021 4.6517,-6.40139 5.04345,-1.36323 9.69186,3.19314 8.31064,8.1461 -0.52257,1.87392 -2.73769,4.08181 -4.55402,4.53917 -1.67808,0.42255 -2.62687,0.39633 -4.01102,-0.11081 z m 4.26525,-4.82529 c 0.71691,-1.09414 0.53379,-2.37215 -0.46825,-3.26792 -0.9779,-0.8742 -1.6557,-0.96253 -2.8091,-0.36609 -1.52563,0.78893 -1.78001,2.86739 -0.49574,4.05059 1.15356,1.06279 2.93246,0.86638 3.77309,-0.41658 z m -31.5253,13.17227 c 3.67969,-1.0497 6.30362,-2.63744 9.32937,-5.64519 2.31845,-2.30467 2.881,-3.05756 4.00651,-5.36223 0.72015,-1.47461 1.50945,-3.44311 1.75402,-4.37444 0.46181,-1.75866 0.93545,-7.47889 0.61926,-7.47889 -0.0992,0 -1.24469,0.44059 -2.54557,0.97909 -7.12901,2.95106 -14.63588,3.59336 -21.77137,1.86279 -5.01823,-1.21708 -5.604243,-1.95421 -4.20063,-5.28388 0.093,-0.22061 -0.62142,-0.15631 -2.219371,0.19975 -2.669247,0.59477 -8.383393,1.0842 -10.542989,0.90304 l -1.440768,-0.12086 -0.178904,1.08281 c -0.298428,1.80623 -0.198415,4.64112 0.237333,6.72726 1.785105,8.54619 8.368418,15.08017 17.075329,16.94737 2.53283,0.54316 7.1602,0.33862 9.87778,-0.43662 z M 97.794282,129.63107 c -0.631218,-0.69749 -0.603462,-2.37742 0.04904,-2.96792 0.52962,-0.4793 1.92221,-0.62055 2.475528,-0.25109 1.01654,0.67877 1.13767,2.38772 0.23333,3.29206 -0.606352,0.60635 -2.180784,0.56465 -2.757895,-0.073 z m 17.474618,0.073 c -0.90434,-0.90434 -0.78321,-2.61329 0.23333,-3.29206 0.58836,-0.39285 2.05525,-0.21847 2.52457,0.30013 0.63122,0.69748 0.60346,2.37742 -0.049,2.96792 -0.65273,0.59071 -2.12907,0.60379 -2.70886,0.024 z m 3.01041,-8.44202 c 2.94359,-0.51332 6.58925,-1.73038 8.9907,-3.00145 2.13985,-1.13261 2.18995,-1.28205 2.21213,-6.59902 0.0233,-5.57318 -0.91745,-9.33913 -3.03156,-12.136316 -2.63481,-3.486119 -5.88408,-4.788924 -16.55363,-6.637229 -4.07576,-0.706051 -7.06307,-1.665902 -9.29655,-2.987074 -1.209487,-0.715443 -1.678286,-0.788889 -1.97556,-0.675461 -2.19261,0.836616 -0.318291,1.399157 -0.329263,2.815753 -0.01223,1.579035 -0.151458,2.665012 -0.376418,2.936073 -0.196355,0.236593 -1.076621,0.638278 -1.956146,0.892634 -2.375977,0.687123 -6.181726,2.747204 -8.294349,4.48979 -3.752411,3.09517 -6.248229,7.79578 -6.838746,12.88006 l -0.183304,1.57823 1.84564,0.60588 c 2.874125,0.94351 5.602105,1.266 9.19051,1.08645 3.752014,-0.18774 5.025015,-0.42019 9.951026,-1.81712 l 3.60103,-1.02119 0.77341,0.57489 c 1.11758,0.83071 1.10945,1.79282 -0.0355,4.20376 -0.54548,1.14863 -0.90412,2.14229 -0.79699,2.20815 0.17983,0.11055 2.62948,0.58983 4.28702,0.83877 1.8073,0.27144 6.65133,0.14201 8.81655,-0.23558 z m -44.728013,-7.83658 1.177166,-1.19945 h -4.071254 -4.071254 l 1.177166,1.19945 c 1.129298,1.15067 1.246981,1.19944 2.894088,1.19944 1.647107,0 1.76479,-0.0488 2.894088,-1.19944 z m 72.941233,0.15439 c 0.58863,-0.57478 1.07023,-1.11453 1.07023,-1.19945 0,-0.0849 -1.778,-0.15439 -3.95111,-0.15439 -2.17311,0 -3.95111,0.0805 -3.95111,0.17883 0,0.0984 0.50837,0.63811 1.1297,1.19945 1.04229,0.94164 1.26521,1.02061 2.88088,1.02061 1.6388,0 1.81986,-0.0671 2.82141,-1.04505 z m -86.341912,-1.83772 -2.600555,-2.60056 -0.865129,0.82885 c -1.359111,1.30211 -1.383136,1.96909 -0.11761,3.26511 l 1.081105,1.10715 h 2.551372 2.551372 z m 97.488152,1.69852 c 1.23524,-1.19724 1.21806,-2.09535 -0.0639,-3.33784 l -0.99452,-0.96393 -2.6019,2.6019 -2.6019,2.6019 h 2.66576 c 2.61606,0 2.68313,-0.0168 3.59643,-0.90203 z m -81.619339,-5.91408 1.975556,-0.66278 1.159066,-2.16496 c 0.637487,-1.19073 1.624155,-2.79854 2.192595,-3.57291 1.164546,-1.586425 3.953545,-4.253527 5.558781,-5.315821 1.10836,-0.733478 1.097307,-0.704407 1.550719,-4.078728 l 0.175157,-1.303533 -3.907048,-0.138943 C 80.344529,90.133201 77.66804,89.559675 73.8951,87.96845 l -2.306491,-0.972755 -1.030144,0.650209 c -2.35687,1.487613 -7.018017,3.174811 -10.488334,3.796467 -0.855781,0.1533 -2.792531,0.369498 -4.303888,0.480438 -2.734511,0.200726 -2.747922,0.205365 -2.747922,0.950416 0,2.936247 2.154833,7.262735 5.083793,10.207285 2.417131,2.42999 5.566299,4.20013 8.745095,4.91559 2.599194,0.58501 6.64662,0.37785 9.172222,-0.46947 z M 61.946382,95.47591 c -1.185869,-1.310371 -0.322994,-3.428724 1.396632,-3.428724 2.614326,0 2.685043,3.668536 0.07507,3.894246 -0.68403,0.05915 -1.122347,-0.07949 -1.471699,-0.465522 z m 14.634197,-0.0457 c -1.160436,-1.282268 -0.282131,-3.383025 1.414408,-3.383025 1.113711,0 1.928518,0.83468 1.928518,1.975556 0,1.140875 -0.814807,1.975555 -1.928518,1.975555 -0.5438,0 -1.103872,-0.224949 -1.414408,-0.568086 z m 72.654741,12.04335 c 4.44446,-1.54563 8.05973,-4.60312 10.10296,-8.54423 1.33333,-2.571811 1.7784,-4.026939 2.02981,-6.636304 l 0.18025,-1.870826 -3.81779,-0.136095 c -4.20147,-0.149772 -6.94355,-0.727413 -10.48171,-2.208051 -1.14673,-0.47988 -2.21197,-0.892866 -2.36719,-0.917747 -0.15522,-0.02488 -1.61572,0.61608 -3.24555,1.424358 -3.76,1.86468 -7.32588,2.824934 -12.065,3.248973 -2.72398,0.24373 -3.73945,0.434964 -3.73945,0.704212 0,0.203291 0.92944,1.305115 2.06543,2.448498 2.29484,2.30978 3.72514,4.737187 4.70674,7.987982 0.56897,1.88426 0.71542,2.09884 1.95141,2.85936 1.59689,0.98257 4.16413,1.95068 6.09857,2.29978 2.40495,0.434 6.29647,0.13475 8.58152,-0.65991 z M 134.88325,95.254682 c -0.66707,-0.848035 -0.7206,-1.293531 -0.26046,-2.167716 0.43741,-0.831011 0.7876,-1.030355 1.81901,-1.035458 1.1062,-0.0055 1.90147,0.845161 1.86867,1.998752 -0.0544,1.914675 -2.2591,2.689454 -3.42722,1.204422 z m 15.05009,0.527627 c -0.44623,-0.297959 -0.95947,-1.351755 -0.95947,-1.97002 0,-1.484795 2.46947,-2.370075 3.48404,-1.248992 0.63122,0.697489 0.60346,2.377422 -0.049,2.967926 -0.52962,0.479299 -1.92221,0.620546 -2.47553,0.251086 z M 60.638321,87.113055 c 2.559307,-0.566222 6.30619,-2.126179 8.607777,-3.583716 0.931333,-0.58979 1.898003,-1.073552 2.148156,-1.075027 0.250152,-0.0015 1.557514,0.514058 2.905248,1.145627 5.163596,2.419743 11.355805,3.217643 15.689929,2.021733 L 91.823875,85.115496 91.78819,82.57827 C 91.636551,71.796656 82.810143,62.814482 71.774558,62.211445 61.409213,61.645032 52.497864,68.284801 49.885568,78.520741 c -0.418455,1.639661 -0.546106,7.935848 -0.179091,8.833424 0.201592,0.493018 0.501482,0.518098 4.515555,0.377636 2.375279,-0.08312 5.24696,-0.360044 6.416289,-0.618746 z m 45.218249,90.153075 c -5.32458,-1.07306 -7.315795,-7.93132 -3.43075,-11.81636 1.35988,-1.35988 2.91441,-1.98797 4.92028,-1.98797 5.2595,0 8.53617,5.37128 6.17148,10.11659 -0.84617,1.69804 -2.76877,3.27639 -4.33612,3.55972 -0.54378,0.0983 -1.2427,0.22206 -1.55314,0.27502 -0.31045,0.053 -1.10773,-0.0132 -1.77175,-0.147 z m 3.52941,-4.93461 c 0.90011,-0.9001 0.98067,-1.10737 0.83952,-2.15972 -0.22727,-1.69443 -1.2622,-2.63017 -2.90897,-2.63017 -1.09672,0 -1.40835,0.1361 -2.11025,0.92167 -1.785,1.99777 -0.48104,4.82511 2.23859,4.85388 0.71332,0.008 1.18991,-0.23445 1.94111,-0.98566 z M 68.126938,136.56671 c -1.611786,-0.42554 -3.880161,-2.77261 -4.367049,-4.51856 -1.703128,-6.10732 5.662729,-10.95914 10.53206,-6.93737 2.359005,1.94839 3.070596,5.3395 1.698306,8.09333 -1.468217,2.94633 -4.511208,4.2476 -7.863317,3.3626 z m 3.705837,-4.50969 c 1.710655,-1.54586 0.506309,-4.44984 -1.845453,-4.44984 -0.77341,0 -2.19957,1.26425 -2.357373,2.08975 -0.205664,1.07586 0.50036,2.39923 1.505465,2.82185 1.049788,0.4414 1.8494,0.30452 2.697361,-0.46176 z'
                id='path166'
            />
        </g>
    </svg>
)

export const MusicIcon = () => (
    <svg
        width='22.961842mm'
        height='25.6457mm'
        viewBox='0 0 22.961842 25.6457'
        xmlns='http://www.w3.org/2000/svg'
    >
        <g
            id='ref_guitar'
            transform='matrix(0.11274698,0,0,0.11274698,-1.4353481,-0.51462315)'
        >
            <g
                id='g18'
                inkscape:export-filename='path14.svg'
                inkscape:export-xdpi='96'
                inkscape:export-ydpi='96'
            >
                <path
                    fill='#984427'
                    stroke='#000000'
                    stroke-width='4.16px'
                    stroke-miterlimit='10'
                    d='m 54.52,219.21 c 14.36,17.07 43.44,11.54 55.57,-0.98 12.83,-13.24 14.19,-29.43 13.42,-36.5 -0.24,-2.22 0.66,-4.37 2.29,-5.89 7.03,-6.57 10.96,-17.39 9.19,-26.31 -2.59,-13.04 -16.31,-19.23 -17.12,-19.55 -2.26,-0.9 -14.67,-8.87 -26.86,-4.35 -10.04,3.73 -15.89,14.7 -18.03,26.3 -1.38,7.46 -4.89,8.45 -5.5,8.78 -7.99,4.3 -44.21,21.37 -12.97,58.5 z'
                    id='path1'
                />
                <path
                    fill='#f19e32'
                    stroke='#000000'
                    stroke-width='1.85px'
                    stroke-miterlimit='10'
                    d='m 55.92,216.52 c 14.42,15.84 33.45,11.46 45.08,-0.37 12.3,-12.51 15.25,-26.77 14.74,-33.25 -0.16,-2.03 0.1,-8.1 1.66,-9.55 6.72,-6.23 11.96,-16.55 10.55,-24.69 -2.06,-11.91 -15.07,-17.51 -15.83,-17.74 -2.23,-0.67 -9.1,-7.95 -22.85,-1.86 -11.22,4.98 -12.86,14.66 -15.61,25.26 -1.39,5.36 -7.72,8.38 -8.27,8.73 -9.86,6.32 -35.62,24.75 -9.47,53.46 z'
                    id='path2'
                />
                <circle
                    fill='#572b13'
                    cx='96.489998'
                    cy='159.38'
                    r='13.67'
                    id='circle2'
                />
                <path
                    fill='#572b13'
                    stroke='#000000'
                    stroke-width='3.24px'
                    stroke-miterlimit='10'
                    d='M 172.7,13.37 156.09,7.24 c -3.86,-1.74 -7.86,-1.55 -9.6,2.31 l -11.05,26 c -1.74,3.86 0.26,6.21 4.12,7.95 l 0.62,0.28 -42.88,84.73 c -2.01,4.36 -0.09,9.56 4.27,11.57 l 6.76,3.12 c 4.36,2.01 9.56,0.09 11.57,-4.27 l 36.39,-85.09 c 3.53,0.87 7.31,-0.88 8.86,-4.3 l 12.31,-26.2 c 1.74,-3.86 -0.89,-8.24 -4.75,-9.98 z'
                    id='path3'
                />
                <g id='g10'>
                    <path
                        fill='none'
                        stroke='#fac499'
                        stroke-width='1.85px'
                        stroke-linecap='round'
                        stroke-miterlimit='10'
                        d='M 67.68,202.95 C 90.37,154.1 131.24,68.08 153.93,19.23'
                        id='path4'
                    />
                    <path
                        fill='none'
                        stroke='#fac499'
                        stroke-width='1.85px'
                        stroke-linecap='round'
                        stroke-miterlimit='10'
                        d='M 78.81,206.99 C 100.32,157.6 133.53,90.44 155.04,41.05'
                        id='path5'
                    />
                    <path
                        fill='none'
                        stroke='#fac499'
                        stroke-width='1.39px'
                        stroke-linecap='round'
                        stroke-miterlimit='10'
                        d='M 72.8,204.8 C 94.88,155.67 134.53,74.11 156.61,24.97'
                        id='path6'
                    />
                    <circle
                        fill='#572b13'
                        stroke='#000000'
                        stroke-width='1.85px'
                        stroke-miterlimit='10'
                        cx='137.24001'
                        cy='13.25'
                        r='5.8299999'
                        id='circle6'
                    />
                    <circle
                        fill='#fac499'
                        cx='151.88'
                        cy='18.440001'
                        r='3.05'
                        id='circle7'
                    />
                    <circle
                        fill='#fac499'
                        cx='144.67'
                        cy='33.330002'
                        r='2.5999999'
                        id='circle8'
                    />
                    <circle
                        fill='#fac499'
                        cx='157.33'
                        cy='39.150002'
                        r='3.1199999'
                        id='circle9'
                    />
                    <circle
                        fill='#fac499'
                        cx='158.69'
                        cy='24.700001'
                        r='3.1199999'
                        id='circle10'
                    />
                </g>
                <rect
                    fill='#572b13'
                    x='66.029999'
                    y='195.87'
                    width='10.69'
                    height='26.52'
                    rx='2.25'
                    ry='2.25'
                    transform='rotate(-65.21,71.385328,209.14664)'
                    id='rect10'
                />
                <path
                    fill='#572b13'
                    stroke='#000000'
                    stroke-width='1.85px'
                    stroke-miterlimit='10'
                    d='m 127.43,33.81 c -2.03,-2.5 -2.61,-7.69 -0.11,-9.71 2.5,-2.03 6.18,-1.64 8.21,0.86 2.03,2.5 1.64,6.18 -0.86,8.21 -2.5,2.03 -5.21,3.15 -7.24,0.65 z'
                    id='path10'
                />
                <circle
                    fill='#572b13'
                    stroke='#000000'
                    stroke-width='1.85px'
                    stroke-miterlimit='10'
                    cx='181.19'
                    cy='31.08'
                    r='5.8299999'
                    id='circle11'
                />
                <path
                    fill='#572b13'
                    stroke='#000000'
                    stroke-width='1.85px'
                    stroke-miterlimit='10'
                    d='m 170.2,51.81 c -2.03,-2.5 -2.61,-7.69 -0.11,-9.71 2.5,-2.03 6.18,-1.64 8.21,0.86 2.03,2.5 1.64,6.18 -0.86,8.21 -2.5,2.03 -5.21,3.15 -7.24,0.65 z'
                    id='path11'
                />
                <g id='g17'>
                    <path
                        fill='#fd7f2d'
                        d='m 51.356335,116.77153 c -0.100489,-9.25757 -1.394288,-16.781702 -1.921856,-26.00159 -0.163295,-2.725771 -3.002117,-4.421526 -5.476664,-3.2659 -6.732779,3.165411 -12.699328,5.727886 -19.344179,8.830492 -0.854158,0.401957 -1.381727,1.293799 -1.30636,2.235885 0.590374,7.109613 1.30636,13.817263 1.004893,21.655423 -1.40685,-0.57781 -2.688088,-0.60293 -3.328707,-0.56525 -3.466878,0.18842 -8.252678,2.87651 -8.252678,6.95888 0,3.76835 4.145181,6.68254 8.252678,6.68254 4.107498,0 7.951212,-3.54225 7.951212,-7.3106 0,-0.47732 -0.10049,-0.94208 -0.251224,-1.38172 -0.150733,-6.51924 -0.11305,-12.25969 -0.314028,-18.94222 0,-0.3894 0.2261,-0.74111 0.590374,-0.87928 5.175196,-1.89673 9.948435,-4.823484 15.098508,-6.770464 0.489885,-0.188417 1.017454,0.163296 1.055137,0.690864 0.364274,4.68531 0.766231,9.01891 1.130504,13.75446 -0.690863,-0.17586 -1.41941,-0.26378 -2.160519,-0.26378 -3.680418,0 -7.39852,2.83882 -7.39852,6.18008 0,3.34127 3.743224,5.08727 7.423643,5.08727 3.680418,0 7.109614,-2.28613 7.109614,-5.63996 0,-0.38939 0.213539,-0.69086 0.11305,-1.05513 z'
                        id='path12'
                        style='stroke-width:1'
                    />
                    <path
                        fill='#439dc3'
                        d='M 93.12132,47.629587 C 92.995726,36.059296 91.378711,26.655492 90.719346,15.132298 90.515257,11.725578 86.967244,9.6061906 83.874507,11.050514 75.45975,15.006706 68.002644,18.209336 59.697781,22.087033 c -1.067542,0.502373 -1.726907,1.617014 -1.632714,2.794452 0.737863,8.885732 1.632714,17.269091 1.255934,27.065374 -1.758307,-0.722163 -3.359622,-0.75356 -4.160281,-0.706463 -4.332971,0.235487 -10.314356,3.59511 -10.314356,8.697342 0,4.709751 5.180728,8.351958 10.314356,8.351958 5.133631,0 9.937577,-4.427166 9.937577,-9.136918 0,-0.596568 -0.125594,-1.177438 -0.313983,-1.726908 -0.188391,-8.147871 -0.141294,-15.322393 -0.39248,-23.674353 0,-0.486674 0.282586,-0.92625 0.73786,-1.098941 6.468061,-2.370575 12.433746,-6.028482 18.870407,-8.461855 0.612267,-0.235487 1.271632,0.20409 1.318731,0.863455 0.455274,5.855792 0.957648,11.272007 1.412925,17.190594 -0.863455,-0.219788 -1.774007,-0.329683 -2.700258,-0.329683 -4.599857,0 -9.246813,3.548014 -9.246813,7.723994 0,4.175978 4.678354,6.358164 9.278211,6.358164 4.599858,0 8.885732,-2.857249 8.885732,-7.048928 0,-0.486674 0.266886,-0.863455 0.141292,-1.31873 z'
                        id='path13'
                        style='stroke-width:0.999994'
                    />
                    <g
                        id='g15'
                        transform='matrix(1.8486292,0,0,1.8486292,-132.01484,-171.47837)'
                        style='stroke-width:0.540941'
                    >
                        <ellipse
                            fill='#fa7e51'
                            cx='164.72'
                            cy='187.96001'
                            rx='6.8800001'
                            ry='8.5500002'
                            transform='rotate(-81.61,164.73112,187.95669)'
                            id='ellipse14'
                            style='stroke-width:0.540941'
                        />
                        <path
                            fill='#fa7e51'
                            d='m 169.92,184.54 c 1.74,-8.05 3.44,-15.58 5.18,-23.63 0.48,-2.21 3.06,-3.41 4.71,-1.86 2.18,2.05 5.01,4.94 7.07,8.83 3.99,7.53 -0.05,14.78 -6.54,15.2 -0.37,0.02 7.75,-8.24 -2.83,-13.27 -1.75,6.81 -2.71,12.22 -4.46,19.04'
                            id='path15'
                            style='stroke-width:0.540941'
                        />
                    </g>
                    <g
                        id='g16'
                        transform='matrix(2.3960102,0.70992893,-0.70992893,2.3960102,-121.19285,-348.98569)'
                        style='stroke-width:0.400164'
                    >
                        <ellipse
                            fill='#fdb43b'
                            cx='162.82001'
                            cy='138.63'
                            rx='5.54'
                            ry='4.4699998'
                            id='ellipse15'
                            style='stroke-width:0.400164'
                        />
                        <path
                            fill='#fdb43b'
                            d='m 165.83,135.95 c 0.36,-5.33 0.74,-10.32 1.09,-15.66 0.1,-1.46 1.64,-2.47 2.84,-1.64 1.59,1.11 3.68,2.7 5.37,5 3.27,4.45 3.2,3.91 4.22,8 0.07,0.3 -2.78,-3.65 -10.05,-5.88 -0.48,4.54 -0.58,8.1 -1.06,12.64'
                            id='path16'
                            style='stroke-width:0.400164'
                        />
                    </g>
                </g>
            </g>
        </g>
    </svg>
)

export const LoadingIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 24 24'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M12 22c5.421 0 10-4.579 10-10h-2c0 4.337-3.663 8-8 8s-8-3.663-8-8c0-4.336 3.663-8 8-8V2C6.579 2 2 6.58 2 12c0 5.421 4.579 10 10 10z'></path>
    </svg>
)

export const CommentIcon = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='25'
        height='25'
        viewBox='0 0 24 24'
        fill='currentColor'
        color='currentColor'
    >
        <path d='M12 1.75C13.4892 1.75 14.9255 1.78112 16.2754 1.83887L16.3418 1.8418C17.509 1.89169 18.4719 1.93277 19.2588 2.0918C20.0995 2.26171 20.7921 2.57464 21.4023 3.18945C22.6167 4.41312 22.6298 5.95045 22.71 8.22363C22.7359 8.95905 22.75 9.72053 22.75 10.5C22.75 11.2795 22.7359 12.0409 22.71 12.7764C22.6298 15.0495 22.6167 16.5869 21.4023 17.8105C20.7921 18.4254 20.0995 18.7383 19.2588 18.9082C18.4718 19.0672 17.5091 19.1083 16.3418 19.1582L16.2754 19.1611C15.5355 19.1928 14.7696 19.2165 13.9834 19.2314C13.1863 19.2466 12.9733 19.2607 12.7988 19.3271C12.6239 19.3938 12.4615 19.5198 11.873 20.0244L9.69336 21.8936C9.4251 22.1236 9.08286 22.25 8.72949 22.25C7.91249 22.2498 7.25022 21.5875 7.25 20.7705V19.1396C6.26419 19.0959 5.43456 19.0483 4.74121 18.9082C3.90049 18.7383 3.20788 18.4254 2.59766 17.8105C1.38331 16.5869 1.37023 15.0495 1.29004 12.7764C1.26409 12.0409 1.25 11.2795 1.25 10.5C1.25 9.72053 1.26409 8.95905 1.29004 8.22363C1.37023 5.95046 1.38331 4.41312 2.59766 3.18945C3.20788 2.57464 3.90049 2.26171 4.74121 2.0918C5.52815 1.93277 6.49097 1.89169 7.6582 1.8418L7.72461 1.83887C9.0745 1.78112 10.5108 1.75 12 1.75ZM7.5 11.5C6.94772 11.5 6.5 11.9477 6.5 12.5C6.5 13.0523 6.94772 13.5 7.5 13.5H13C13.5523 13.5 14 13.0523 14 12.5C14 11.9477 13.5523 11.5 13 11.5H7.5ZM7.5 7.5C6.94772 7.5 6.5 7.94772 6.5 8.5C6.5 9.05228 6.94772 9.5 7.5 9.5H16.5C17.0523 9.5 17.5 9.05228 17.5 8.5C17.5 7.94772 17.0523 7.5 16.5 7.5H7.5Z'></path>
    </svg>
)

export const PasswordIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M376 192h-24v-46.7c0-52.7-42-96.5-94.7-97.3-53.4-.7-97.3 42.8-97.3 96v48h-24c-22 0-40 18-40 40v192c0 22 18 40 40 40h240c22 0 40-18 40-40V232c0-22-18-40-40-40zM270 316.8v68.8c0 7.5-5.8 14-13.3 14.4-8 .4-14.7-6-14.7-14v-69.2c-11.5-5.6-19.1-17.8-17.9-31.7 1.4-15.5 14.1-27.9 29.6-29 18.7-1.3 34.3 13.5 34.3 31.9 0 12.7-7.3 23.6-18 28.8zM324 192H188v-48c0-18.1 7.1-35.1 20-48s29.9-20 48-20 35.1 7.1 48 20 20 29.9 20 48v48z'></path>
    </svg>
)

export const LinkIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 512 512'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M326.612 185.391c59.747 59.809 58.927 155.698.36 214.59-.11.12-.24.25-.36.37l-67.2 67.2c-59.27 59.27-155.699 59.262-214.96 0-59.27-59.26-59.27-155.7 0-214.96l37.106-37.106c9.84-9.84 26.786-3.3 27.294 10.606.648 17.722 3.826 35.527 9.69 52.721 1.986 5.822.567 12.262-3.783 16.612l-13.087 13.087c-28.026 28.026-28.905 73.66-1.155 101.96 28.024 28.579 74.086 28.749 102.325.51l67.2-67.19c28.191-28.191 28.073-73.757 0-101.83-3.701-3.694-7.429-6.564-10.341-8.569a16.037 16.037 0 0 1-6.947-12.606c-.396-10.567 3.348-21.456 11.698-29.806l21.054-21.055c5.521-5.521 14.182-6.199 20.584-1.731a152.482 152.482 0 0 1 20.522 17.197zM467.547 44.449c-59.261-59.262-155.69-59.27-214.96 0l-67.2 67.2c-.12.12-.25.25-.36.37-58.566 58.892-59.387 154.781.36 214.59a152.454 152.454 0 0 0 20.521 17.196c6.402 4.468 15.064 3.789 20.584-1.731l21.054-21.055c8.35-8.35 12.094-19.239 11.698-29.806a16.037 16.037 0 0 0-6.947-12.606c-2.912-2.005-6.64-4.875-10.341-8.569-28.073-28.073-28.191-73.639 0-101.83l67.2-67.19c28.239-28.239 74.3-28.069 102.325.51 27.75 28.3 26.872 73.934-1.155 101.96l-13.087 13.087c-4.35 4.35-5.769 10.79-3.783 16.612 5.864 17.194 9.042 34.999 9.69 52.721.509 13.906 17.454 20.446 27.294 10.606l37.106-37.106c59.271-59.259 59.271-155.699.001-214.959z'></path>
    </svg>
)

export const EditIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 24 24'
        height={25}
        width={25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path fill='none' d='M0 0h24v24H0z'></path>
        <path d='M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04a.996.996 0 000-1.41l-2.34-2.34a.996.996 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z'></path>
    </svg>
)

export const SunIcon = (P: any) => (
    <svg
        width={P.size || 25}
        height={P.size || 25}
        viewBox='0 0 24 24'
        fill='undefined'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill-rule='evenodd'
            clip-rule='evenodd'
            d='M11.9999 2.40002C12.3182 2.40002 12.6234 2.52645 12.8484 2.7515C13.0735 2.97654 13.1999 3.28176 13.1999 3.60002V4.80002C13.1999 5.11828 13.0735 5.42351 12.8484 5.64855C12.6234 5.8736 12.3182 6.00002 11.9999 6.00002C11.6816 6.00002 11.3764 5.8736 11.1514 5.64855C10.9263 5.42351 10.7999 5.11828 10.7999 4.80002V3.60002C10.7999 3.28176 10.9263 2.97654 11.1514 2.7515C11.3764 2.52645 11.6816 2.40002 11.9999 2.40002ZM16.7999 12C16.7999 13.2731 16.2942 14.494 15.394 15.3941C14.4938 16.2943 13.2729 16.8 11.9999 16.8C10.7269 16.8 9.50596 16.2943 8.60579 15.3941C7.70562 14.494 7.1999 13.2731 7.1999 12C7.1999 10.727 7.70562 9.50609 8.60579 8.60591C9.50596 7.70574 10.7269 7.20002 11.9999 7.20002C13.2729 7.20002 14.4938 7.70574 15.394 8.60591C16.2942 9.50609 16.7999 10.727 16.7999 12ZM16.2431 17.94L17.0915 18.7884C17.3178 19.007 17.6209 19.128 17.9356 19.1252C18.2502 19.1225 18.5512 18.9963 18.7737 18.7738C18.9962 18.5513 19.1224 18.2503 19.1251 17.9357C19.1278 17.6211 19.0069 17.3179 18.7883 17.0916L17.9399 16.2432C17.7136 16.0246 17.4105 15.9037 17.0958 15.9064C16.7812 15.9092 16.4802 16.0354 16.2577 16.2578C16.0352 16.4803 15.909 16.7813 15.9063 17.0959C15.9036 17.4106 16.0245 17.7137 16.2431 17.94ZM18.7871 5.21162C19.0121 5.43666 19.1384 5.74183 19.1384 6.06002C19.1384 6.37822 19.0121 6.68339 18.7871 6.90842L17.9399 7.75682C17.8292 7.87144 17.6968 7.96286 17.5504 8.02575C17.404 8.08864 17.2465 8.12174 17.0872 8.12313C16.9278 8.12451 16.7698 8.09415 16.6224 8.03381C16.4749 7.97347 16.3409 7.88437 16.2282 7.7717C16.1156 7.65903 16.0265 7.52505 15.9661 7.37757C15.9058 7.23009 15.8754 7.07208 15.8768 6.91274C15.8782 6.75341 15.9113 6.59594 15.9742 6.44954C16.0371 6.30313 16.1285 6.17072 16.2431 6.06002L17.0915 5.21162C17.3165 4.98666 17.6217 4.86028 17.9399 4.86028C18.2581 4.86028 18.5621 4.98666 18.7871 5.21162ZM20.3999 13.2C20.7182 13.2 21.0234 13.0736 21.2484 12.8486C21.4735 12.6235 21.5999 12.3183 21.5999 12C21.5999 11.6818 21.4735 11.3765 21.2484 11.1515C21.0234 10.9265 20.7182 10.8 20.3999 10.8H19.1999C18.8816 10.8 18.5764 10.9265 18.3514 11.1515C18.1263 11.3765 17.9999 11.6818 17.9999 12C17.9999 12.3183 18.1263 12.6235 18.3514 12.8486C18.5764 13.0736 18.8816 13.2 19.1999 13.2H20.3999ZM11.9999 18C12.3182 18 12.6234 18.1265 12.8484 18.3515C13.0735 18.5765 13.1999 18.8818 13.1999 19.2V20.4C13.1999 20.7183 13.0735 21.0235 12.8484 21.2486C12.6234 21.4736 12.3182 21.6 11.9999 21.6C11.6816 21.6 11.3764 21.4736 11.1514 21.2486C10.9263 21.0235 10.7999 20.7183 10.7999 20.4V19.2C10.7999 18.8818 10.9263 18.5765 11.1514 18.3515C11.3764 18.1265 11.6816 18 11.9999 18ZM6.0599 7.75682C6.17132 7.86832 6.3036 7.95677 6.4492 8.01714C6.5948 8.07751 6.75086 8.10861 6.90848 8.10867C7.0661 8.10872 7.22218 8.07773 7.36782 8.01747C7.51347 7.9572 7.64581 7.86884 7.7573 7.75742C7.86879 7.64601 7.95725 7.51373 8.01762 7.36813C8.07799 7.22253 8.10909 7.06647 8.10915 6.90885C8.1092 6.75123 8.07821 6.59514 8.01795 6.4495C7.95768 6.30386 7.86932 6.17152 7.7579 6.06002L6.9083 5.21162C6.68198 4.99303 6.37886 4.87208 6.06422 4.87482C5.74958 4.87755 5.44861 5.00375 5.22612 5.22624C5.00363 5.44873 4.87743 5.74971 4.87469 6.06434C4.87196 6.37898 4.99291 6.6821 5.2115 6.90842L6.0599 7.75682ZM7.7567 17.94L6.9083 18.7884C6.68198 19.007 6.37886 19.128 6.06422 19.1252C5.74958 19.1225 5.44861 18.9963 5.22612 18.7738C5.00363 18.5513 4.87743 18.2503 4.87469 17.9357C4.87196 17.6211 4.99291 17.3179 5.2115 17.0916L6.0599 16.2432C6.28623 16.0246 6.58935 15.9037 6.90398 15.9064C7.21862 15.9092 7.51959 16.0354 7.74208 16.2578C7.96457 16.4803 8.09078 16.7813 8.09351 17.0959C8.09625 17.4106 7.97529 17.7137 7.7567 17.94ZM4.7999 13.2C5.11816 13.2 5.42339 13.0736 5.64843 12.8486C5.87347 12.6235 5.9999 12.3183 5.9999 12C5.9999 11.6818 5.87347 11.3765 5.64843 11.1515C5.42339 10.9265 5.11816 10.8 4.7999 10.8H3.5999C3.28164 10.8 2.97642 10.9265 2.75137 11.1515C2.52633 11.3765 2.3999 11.6818 2.3999 12C2.3999 12.3183 2.52633 12.6235 2.75137 12.8486C2.97642 13.0736 3.28164 13.2 3.5999 13.2H4.7999Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const MoonIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 384 512'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M223.5 32C100 32 0 132.3 0 256S100 480 223.5 480c60.6 0 115.5-24.2 155.8-63.4c5-4.9 6.3-12.5 3.1-18.7s-10.1-9.7-17-8.5c-9.8 1.7-19.8 2.6-30.1 2.6c-96.9 0-175.5-78.8-175.5-176c0-65.8 36-123.1 89.3-153.3c6.1-3.5 9.2-10.5 7.7-17.3s-7.3-11.9-14.3-12.5c-6.3-.5-12.6-.8-19-.8z'></path>
    </svg>
)

export const CodeIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='none'
        stroke-width='2'
        viewBox='0 0 24 24'
        stroke-linecap='round'
        stroke-linejoin='round'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='m18 16 4-4-4-4'></path>
        <path d='m6 8-4 4 4 4'></path>
        <path d='m14.5 4-5 16'></path>
    </svg>
)

export const QuestionIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 384 512'
        height='25'
        width='25'
        xmlns='http://www.w3.org/2000/svg'
    >
        <Sprite id='account_question' />
    </svg>
)

export const QuoteIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        stroke-width='0'
        viewBox='0 0 24 24'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M14.4167 6.67891C15.4469 7.77257 16.0001 9 16.0001 10.9897C16.0001 14.4891 13.5436 17.6263 9.96951 19.1768L9.07682 17.7992C12.4121 15.9946 13.0639 13.6539 13.3245 12.178C12.7875 12.4557 12.0845 12.5533 11.3954 12.4895C9.59102 12.3222 8.16895 10.8409 8.16895 9C8.16895 7.067 9.73595 5.5 11.6689 5.5C12.742 5.5 13.7681 5.99045 14.4167 6.67891Z'></path>
    </svg>
)

export const DbQouteIcon = (P: any) => (
    <svg
        stroke='currentColor'
        fill='none'
        stroke-width='0'
        viewBox='0 0 24 24'
        height={P.size || 25}
        width={P.size || 25}
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            d='M9.13456 9H12.1346L10 14.6075H7L9.13456 9Z'
            fill='currentColor'
        ></path>
        <path
            d='M14.1346 9H17.1346L15 14.6075H12L14.1346 9Z'
            fill='currentColor'
        ></path>
    </svg>
)

export const StarIcon = (P: any) => (
    <>
        {P.fill ? (
            <svg
                fill='currentColor'
                stroke-width='0'
                viewBox='0 0 24 24'
                height={P.size || 25}
                width={P.size || 25}
                xmlns='http://www.w3.org/2000/svg'
                class={`fill ${P.className || ''}`}
            >
                <Sprite id='account_star_fill' />
            </svg>
        ) : (
            <svg
                fill='currentColor'
                stroke-width='0'
                viewBox='0 0 24 24'
                height={P.size || 25}
                width={P.size || 25}
                xmlns='http://www.w3.org/2000/svg'
                class={P.className || ''}
            >
                <Sprite id='account_star_halo' />
            </svg>
        )}
    </>
)

export const StatusIcon = () => (
    <svg
        stroke='currentColor'
        fill='currentColor'
        width={25}
        height={25}
        stroke-width='0'
        viewBox='0 0 20 20'
        aria-hidden='true'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path
            fill-rule='evenodd'
            d='M5.05 3.636a1 1 0 010 1.414 7 7 0 000 9.9 1 1 0 11-1.414 1.414 9 9 0 010-12.728 1 1 0 011.414 0zm9.9 0a1 1 0 011.414 0 9 9 0 010 12.728 1 1 0 11-1.414-1.414 7 7 0 000-9.9 1 1 0 010-1.414zM7.879 6.464a1 1 0 010 1.414 3 3 0 000 4.243 1 1 0 11-1.415 1.414 5 5 0 010-7.07 1 1 0 011.415 0zm4.242 0a1 1 0 011.415 0 5 5 0 010 7.072 1 1 0 01-1.415-1.415 3 3 0 000-4.242 1 1 0 010-1.415zM10 9a1 1 0 011 1v.01a1 1 0 11-2 0V10a1 1 0 011-1z'
            clip-rule='evenodd'
        ></path>
    </svg>
)

export const SharpStarIcon = (P: any) => (
    <>
        {P.fill ? (
            <svg
                stroke='currentColor'
                fill='currentColor'
                stroke-width='0'
                viewBox='0 0 512 512'
                height={P.size || 25}
                width={P.size || 25}
                xmlns='http://www.w3.org/2000/svg'
            >
                <path d='M496 203.3H312.36L256 32l-56.36 171.3H16l150.21 105.4-58.5 171.3L256 373.84 404.29 480l-58.61-171.3z'></path>
            </svg>
        ) : (
            <svg
                stroke='currentColor'
                fill='currentColor'
                stroke-width='0'
                viewBox='0 0 512 512'
                height={P.size || 25}
                width={P.size || 25}
                xmlns='http://www.w3.org/2000/svg'
            >
                <path
                    fill='none'
                    stroke-linejoin='round'
                    stroke-width='32'
                    d='M480 208H308L256 48l-52 160H32l140 96-54 160 138-100 138 100-54-160z'
                ></path>
            </svg>
        )}
    </>
)

export const SauceDripSvg = () => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        width='165.62917mm'
        height='57.953285mm'
        viewBox='0 0 165.62917 57.953285'
        version='1.1'
        id='svg1'
        class='sauce-svg'
    >
        <g id='layer1' transform='translate(-22.543594,-34.559588)'>
            <path
                d='m 22.543594,34.559588 v 51.06458 5.82083 0.79375 0.26459 c 5.247504,0.41354 7.89007,-12.754001 12.882572,-13.701331 7.400786,-1.4043 14.646905,14.559161 21.513262,9.365001 16.683797,-20.213193 25.977283,-31.297329 50.879402,-16.930641 4.9514,2.90837 14.29701,20.960637 20.27496,21.129377 7.76182,0.2191 12.5997,-17.059048 19.23258,-20.047078 11.27238,-5.07807 20.49506,-4.665748 31.32139,-1.070198 2.12975,0.70732 8.93106,3.19779 9.525,-0.44097 v -1.5875 -34.66041 H 22.543594'
                id='path7'
                inkscape:export-filename='sauce-dripping.png'
                inkscape:export-xdpi='96'
                inkscape:export-ydpi='96'
            />
        </g>
    </svg>
)

export const RulesIcon = () => (
    <svg
        stroke='currentColor'
        fill='none'
        stroke-width='2'
        viewBox='0 0 24 24'
        stroke-linecap='round'
        stroke-linejoin='round'
        height='1em'
        width='1em'
        xmlns='http://www.w3.org/2000/svg'
    >
        <path d='M12 7v14'></path>
        <path d='M16 12h2'></path>
        <path d='M16 8h2'></path>
        <path d='M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z'></path>
        <path d='M6 12h2'></path>
        <path d='M6 8h2'></path>
    </svg>
)
